/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    my_video_shorts: 'MIS VIDEO SHORTS',
    see_more: 'VER MÁS',
    no_shorts_found: 'No se han encontrado Shorts',
    shorts: 'Shorts',
    general_information: 'Información general',
    gamification: 'Gamificación',
    click_to_select_files: 'Haga clic para seleccionar archivos',
    selected_files: 'Archivos seleccionados',
    uploaded: 'Subido',
    failed: 'Error',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'El sistema analizará automáticamente y seleccionará los documentos más relevantes de la biblioteca de su organización según los requisitos de contenido.',
    select_from_library: ' Seleccionar de la biblioteca',
    search_document: 'Buscar documentos...',
    selected: 'Seleccionado',
    loading_documents: 'Cargando documentos...',
    review_generated_content: 'Revisar contenido generado',
    confirm_and_replace_content: 'Confirmar y reemplazar contenido',
    the_generate_content_will_replace:
      'El contenido generado reemplazará el texto existente en las páginas seleccionadas. Si no desea aplicar estos cambios, puede volver al paso anterior.',
    pages_to_be_updated: 'Páginas a actualizar',
    generated_revisions: 'Revisiones generadas',
    lesson_preview: 'Vista previa de la lección',
    create_new_folder: 'Crear nueva carpeta',
    rename_item: 'Renombrar elemento',
    enter_folder_name: 'Introduzca el nombre de la carpeta:',
    enter_new_name: 'Introduzca un nuevo nombre:',
    folder_name: 'Nombre de la carpeta:',
    new_name: 'Nuevo nombre',
    move_items: 'Mover elementos',
    copy_items: 'Copiar elementos',
    move_here: 'Mover aquí',
    copy_here: 'Copiar aquí',
    select_destination_library_and_folder:
      'Seleccionar biblioteca y carpeta de destino:',
    items_selected: 'Elementos seleccionados',
    version: 'Versión',
    modified_by: 'Modificado por',
    size: 'Tamaño',
    restore: 'Restaurar',
    are_you_sure_you_want_to_restore_this_version:
      '¿Está seguro de que desea restaurar esta versión?',
    this_will_replce_the_current_version_with_the_selected_one:
      'Esto reemplazará la versión actual con la seleccionada.',
    restore_this_version: 'Restaurar esta versión',
    restore_not_available: 'Restauración no disponible',
    version_history: 'Historial de versiones:',
    by_making_items_public:
      'Al hacer públicos los elementos, serán visibles para todos. Por favor, revise los términos y condiciones antes de continuar.',
    the_selected_items_will_be_copied:
      'Los elementos seleccionados se copiarán a su biblioteca pública y serán visibles para todos.',
    the_selected_items_will_be_copied_to_org:
      'Los elementos seleccionados se copiarán a la biblioteca de su organización y serán visibles para todos los miembros de la organización.',
    the_selected_items_will_be_copied_to_your_private:
      'Los elementos seleccionados se copiarán a su biblioteca privada y solo serán visibles para usted.',
    loading_organization: 'Cargando usuarios de la organización...',
    click_download_to_view: 'Haga clic en "Descargar" para ver',
    archive_file: 'Archivo de archivo',
    no_preview_available: 'Vista previa no disponible',
    audit_report: 'Informe de auditoría',
    audit_type: 'Tipo de acción',
    i_agree_to_the_terms_and_conditions: 'Acepto los términos y condiciones.',
    this_file_is_indexed_for_ai: 'Este archivo está indexado para IA.',
    file_is_not_indexed_for_ai: 'Archivo no indexado para IA.',
    no_users_found: 'No se han encontrado usuarios',
    no_users_available: 'No hay usuarios disponibles',
    add_people: 'Añadir personas',
    people: 'Personas',
    access_type: 'Tipo de acceso',
    no_group_found: 'No se han encontrado grupos',
    add_group: 'Añadir grupos',
    groups: 'Grupos',
    users_top: 'usuario(s)',
    confirm_delete: 'Confirmar eliminación',
    do_you_want_remove: '¿Está seguro de que desea eliminar',
    form_this_documents_permissions: 'de los permisos de este documento?',
    no_users_found_in_this_group: 'No se han encontrado usuarios en este grupo',
    add_selected_users: 'Añadir usuarios seleccionados',
    choose_users_from_the_list: 'Seleccione usuarios de la lista',
    selected_users: 'Usuarios seleccionados',
    archived: 'Archivado',
    request_approval: 'Solicitar aprobación',
    document_in_review: 'Documento en revisión',
    approve: 'Aprobar',
    reject: 'Rechazar',
    comment: 'Comentario:',
    enter_your_commit: 'Ingrese su comentario...',
    confirm_cancel: 'Confirmar cancelación',
    upload_3d_zip: 'Subir ZIP 3D',
    delete_items: 'Eliminar elementos',
    video_upload_request: 'Solicitud de subida de vídeo',
    reject_video: 'Rechazar vídeo',
    enter_rejection_reason: 'Ingrese la razón del rechazo...',
    please_provide_a_reason_for_reejection_this_video:
      'Por favor, indique un motivo para rechazar este vídeo:',
    generate_trivia_with_ai: 'Generar trivia con IA',
    select_category: 'Seleccionar categoría:',
    number_of_question: 'Número de preguntas',
    generated_questions: 'Preguntas generadas',
    this_will_clear_all_generate_question:
      'Esto borrará todas las preguntas generadas. ¿Continuar?',
    sure_delete: '¿Está seguro de que desea eliminar?',
    delete_this_question: '¿Está seguro de que desea eliminar esta pregunta?',
    loading_quiz: 'Cargando cuestionario...',
    creteing_file: 'Creando archivo',
    opening_desktop_app: 'Abriendo aplicación de escritorio',
    this_folder_is_empty: 'Esta carpeta está vacía',
    select_a_competition: 'Seleccionar una competición...',
    activity_badges: 'Insignias de actividad',
    awarded_every_badges:
      'Otorgadas cada 4, 8, 16, 32, 64, 128, 256, 512 inicios de sesión',
    learning_badges: 'Insignias de aprendizaje',
    awarded_every_courses:
      'Otorgadas cada 1, 4, 8, 16, 32, 64, 128 cursos completados',
    test_badges: 'Insignias de prueba',
    awarded_every_passes_tests:
      'Otorgadas cada 2, 4, 8, 16, 32, 64, 128, 256 pruebas aprobadas',
    assignment_badges: 'Insignias de tareas',
    awarded_every_passed_assignments:
      'Otorgadas cada 1, 2, 4, 8, 16, 32, 64, 128 tareas aprobadas',
    perfectionism_badges: 'Insignias de perfeccionismo',
    awarded_every_assignments_with_scrore:
      'Otorgadas cada 1, 2, 4, 8, 16, 32, 64, 128 pruebas o tareas con puntuación del 90%+',
    communication_badges: 'Insignias de comunicación',
    awarded_every_topics_or_comments:
      'Otorgadas cada 2, 4, 8, 16, 32, 64, 128, 256 temas o comentarios',
    certification_badges: 'Insignias de certificación',
    awarded_every_certificates:
      'Otorgadas cada 1, 2, 4, 8, 16, 32, 64, 128 certificados',
    level_name: 'Nombre del nivel',
    delete_competition: 'Eliminar competición',
    this_week: 'Esta semana',
    this_year: 'Este año',
    make_organization: 'Hacer organización',
    no_results_found: 'No se han encontrado resultados para',
    no_items_available: 'No hay elementos disponibles',
    help_video: 'Vídeos de ayuda',
    select_a_video_from_the_list:
      'Seleccione un vídeo de la lista para empezar a aprender'
  },
  v4: {
    drop_files: 'Suelta el archivo y selecciona dónde subirlo.',
    duplicate_lessoon: 'La lección ya está presente en el curso',
    skill_rule_title: 'Por favor, introduce el título del viaje de habilidades',
    imageCreatorTitle: 'Creador de Imágenes',
    isTranslated: 'Traducido',
    translationCourseDesc:
      'La traducción de este curso puede tardar unos minutos. ¡Gracias por tu paciencia!',
    translateCourseTip:
      'Crea un curso traducido que puedas modificar de forma independiente del original, incluidas todas las lecciones y páginas.',
    translateModalBtn: 'Traducir',
    translationSuccess: 'El curso "<0/>" ha sido traducido con éxito.',
    translatingCourse: 'Traduciendo el curso...',
    translateModalTitle: 'Traducir Curso',
    translateSelectLang: 'Seleccionar idioma',
    fileDeleteconfirm:
      '¿Estás seguro de que deseas eliminar este archivo? Esta acción no se puede deshacer.',
    fileDeleteMessage: 'Archivo eliminado correctamente.',
    fileDeleteFailedMessage: '¡No se pudo eliminar el archivo!',
    fileDelete: 'Eliminar este archivo.',
    certificate_save_btn: 'Añadir certificado a ',
    maze_path_info: '¡No hay rutas disponibles para el gráfico!',
    file_size_mb: '¡El tamaño del archivo debe ser menor de 25 MB!',
    reports: {
      products: 'Productos',
      users: 'Usuarios',
      ph_username: 'Buscar usuario por nombre de usuario',
      ph_id: 'Buscar usuario por número de ID',
      ph_email: 'Buscar usuario por correo electrónico'
    },
    select_upload_section_id: 'Se requiere archivo de sección',
    tags_all: 'Todos',
    delete_file_confirm: '¿Estás seguro de que deseas eliminar este archivo?',
    delete_file_title: 'Eliminar archivo',
    tooltip_publish: 'Publicar el curso con la opción seleccionada',
    tooltip_save: 'Guardar curso con las actualizaciones actuales',
    tooltip_next: 'Ir al siguiente ajuste del curso',
    tooltip_finish: 'Completar y guardar las actualizaciones actuales',
    stories_modal: {
      title_upload: 'Subir historias',
      title_update: 'Actualizar historias',
      title_audio: 'Archivo de audio de la historia',
      btn_upload: 'Subir',
      btn_update: 'Actualizar',
      btn_close: 'Cerrar',
      btn_cancel: 'Cancelar',
      lbl_cover: 'Imagen de portada de la historia',
      rule_cover: '¡Por favor, sube una portada para el audio de la historia!',
      lbl_title: 'Título del audio de la historia',
      rule_title: '¡Introduce el título del audio de la historia!',
      lbl_description: 'Descripción del audio de la historia',
      rule_description: '¡Introduce una descripción del audio de la historia!',
      lbl_file: 'Subir archivo de audio de la historia',
      rule_file: '¡Por favor, sube el archivo de audio de la historia!',
      rule_file_type: '¡Por favor, sube un archivo de audio válido!',
      lbl_select_file: 'Seleccionar archivo de audio de la historia',
      msg_valid_file: '¡Por favor, selecciona un archivo de audio válido!',
      msg_success: 'Archivo de audio de la historia subido con éxito',
      msg_failed: '¡No se pudo asignar datos multimedia!',
      msg_error: '¡Error al subir el archivo!'
    },
    audio_modal: {
      title_upload: 'Subir',
      title_update: 'Actualizar',
      title_audio: 'Archivo de audio',
      btn_upload: 'Subir',
      btn_update: 'Actualizar',
      btn_close: 'Cerrar',
      btn_cancel: 'Cancelar',
      lbl_cover: 'Portada del audio',
      rule_cover: '¡Por favor, sube una portada para el audio!',
      lbl_title: 'Título del audio',
      rule_title: '¡Introduce el título del audio!',
      lbl_description: 'Descripción del audio',
      rule_description: '¡Introduce una descripción del audio!',
      lbl_file: 'Subir archivo de audio',
      rule_file: '¡Por favor, sube un archivo de audio!',
      rule_file_type: '¡Por favor, sube un archivo de audio válido!',
      lbl_select_file: 'Seleccionar archivo de audio',
      msg_valid_file: '¡Por favor, selecciona un archivo de audio válido!',
      msg_success: 'Archivo de audio subido con éxito',
      msg_failed: '¡No se pudo asignar datos multimedia!',
      msg_error: '¡Error al subir el archivo!'
    },
    info_episode: 'Una imagen de portada para el episodio.',
    btn_delete_episode: 'Eliminar este episodio del pódcast.',
    btn_edit_marketplace: 'Editar detalles del marketplace.',
    btn_save_marketplace: 'Guardar los cambios actuales.',
    btn_ai_podcast: 'Crear un episodio de pódcast con IA.',
    btn_upload_podcast: 'Subir tu propio episodio de pódcast.',
    attach_file: 'Sube archivos para compartir más contenido con tu audiencia',
    fileDownload: 'Descargar este archivo.',
    singleEpishode: 'Episodio',
    podcast_music: 'pódcast, música e historias',
    publishHeader: 'Publicar pódcast, música e historias',
    editHeader: 'Editar pódcast, música e historias',
    createHeader: 'Crear pódcast, música e historias',
    marketplaceHeader:
      'Detalles del marketplace de pódcast, música e historias',
    message_marketplace: '¡Por favor, completa el formulario del marketplace!',
    create_podcast_live: 'Pódcast y música en directo',
    create_podcast_custom: 'Pódcast y música personalizados',
    create_podcast_stories: 'Historia',
    ai_Assisted_podcast_reation: 'Pódcast y música asistidos por IA',
    publishTitle: 'Publica pódcast, música e historias para el público.',
    customButton: 'Crear personalizado',
    customTitle: 'Guarda los cambios realizados en el pódcast.',
    updateButton: 'Actualizar',
    createButton: 'Crear',
    createNewButton: 'Crear nuevo',
    updateTitle:
      'Actualizar los detalles del pódcast, música e historias actuales.',
    createTitle: 'Crear un nuevo pódcast, música e historias',
    createNewTitle:
      'Se creará un nuevo pódcast, música e historias basado en los nuevos datos.',
    podcastTitle: 'Lista de episodios',
    podcastStoryTitle: 'Lista de episodios de historias',
    podcastToolTipTitle: 'Lista de episodios del pódcast',
    uploadAudio: 'Subir',
    aiAudio: 'Audio IA',
    emptyPodcast: 'Aún no hay grabaciones de pódcast, música o historias.',
    emptyStoriesPodcast: 'Todavía no se han añadido historias.',
    emptyCreatePodcast: 'Por favor, crea un pódcast para poder añadir audio.',
    playPodcast: 'Reproducir el pódcast, música e historias seleccionados.',
    pausePodcast: 'Pausar el pódcast, música e historias seleccionados.',
    selectPodcast: 'Seleccionar este pódcast, música e historias.',
    downloadPodcast: 'Descargar este audio.',
    uploadAudioFile: 'Sube un nuevo audio y reemplaza el actual.',
    deleteConfirm: '¿Estás seguro de que deseas eliminar este audio?',
    roomName: 'Nombre del pódcast',
    addGuestTitle: 'AÑADIR INVITADO',
    showTime: 'Hora del show',
    startTime: 'Hora de inicio',
    endTime: 'Hora de finalización',
    erorMsgImg: 'Por favor, selecciona una imagen válida.',
    failedMsgImg: 'Error al cargar la imagen. ¡Inténtalo de nuevo!',
    failedMsgUpload: '¡Error al subir la imagen de portada!',
    btnCoverUpload: 'Subir portada',
    is_private: 'Privado',
    to_attach: 'Adjuntar archivo',
    file_attached: 'Archivo(s) adjunto(s)',
    main_event: 'Evento principal',
    event: 'Eventos',
    upload_pdf: 'Subir PDF',
    portrait: 'Vertical',
    landscape: 'Horizontal',
    import_from_library: 'Importar texto desde la biblioteca multimedia',
    question_answer_ai: 'IA de Preguntas/Respuestas',
    take_maze: 'INICIAR MetaMaze',
    training: 'Formación',
    select_transcribe_locale: 'Selecciona el idioma para transcribir',
    transcribe_limit: 'Por favor, introduce los minutos de transcripción',
    not_complete: 'La información del Marketplace no está completa',
    complete: 'La información del Marketplace está completa',
    not_admin:
      'Se necesitan privilegios de administrador para publicar en el Marketplace',
    no_course:
      'Introduce el título y selecciona una imagen para habilitar el Marketplace',
    scorm_not_complete:
      'Introduce el título y selecciona una imagen para subir el archivo SCORM',
    not_found_maze: 'MetaMaze no encontrado',
    email_require: 'Se requieren correos electrónicos',
    poll_required: 'Se requieren datos de la encuesta',
    alert: '¡Alerta!',
    warning: '¡Advertencia!',
    ok: 'Aceptar',
    cancel: 'Cancelar',
    done: 'Hecho',
    insert: 'Insertar',
    private: 'Privado',
    public: 'Público',
    no_connection: 'Conexión a internet perdida',
    switch: 'Cambiar',
    share_screen: 'Compartir pantalla',
    stop_share_screen: 'Detener compartir pantalla',
    share_screen_with_camera: 'Compartir pantalla con cámara',
    stop_share_screen_with_camera: 'Detener compartir pantalla con cámara',
    camera_on: 'Cámara encendida',
    camera_off: 'Cámara apagada',
    mic_on: 'Activar micrófono',
    mic_off: 'Silenciar micrófono',
    fullscreen: 'Pantalla completa',
    live_now: 'En directo',
    schedule_on: 'Programado para',
    organisations: 'Organizaciones',
    org_groups: 'Grupos de la organización',
    specific_user: 'Usuario específico',
    gif: 'GIF',
    unavailable: 'No disponible',
    yes: 'Sí',
    no: 'No',
    event_duration_message: 'Máximo 300 minutos (5 horas)',
    send_email: 'Enviar notificación por correo electrónico',
    admin_only: 'Solo administradores',
    join: 'Unirse',
    leave: 'Salir',
    share: 'Compartir',
    share_text:
      'Introduce la dirección de correo electrónico de la persona con la que deseas compartir este archivo.',
    share_text_title: 'Compartir PDF',
    share_text_title_txt: 'Compartir texto',
    select_users: 'Seleccionar usuarios',
    delete: 'Eliminar',
    attachment_event: 'Archivos adjuntos para el evento:',
    transcribe_limit: 'Minutos de transcripción',
    monthly_transcribe: 'Límite mensual de transcripción:',
    enable_ai: 'Activar IA:',
    enable_maze: 'Activar MetaMaze:',
    media_service: 'Servicio multimedia',
    allow_others: 'Permitir a otros editar',
    join_breakout_room: 'Unirse a sala de grupo',
    bio: 'Biografía',
    linkedin: 'LinkedIn',
    select_org_report:
      'Busca y selecciona una organización para generar el informe.',
    org_image_not_found: 'Imagen no encontrada',
    insert_text: 'Insertar texto',
    insert_question_answer: 'IA de Preguntas/Respuestas',
    modal_title2: 'Galería de textos',
    my_text_library: 'Mi biblioteca de textos',
    ai: 'IA',
    public_text_library: 'Biblioteca pública de textos',
    organization_text_library: 'Biblioteca de textos de la organización',
    no_transcribed_text: 'No se han encontrado textos transcritos',
    public_text_not_found: 'Texto transcrito público no encontrado',
    org_text_not_found: 'Texto transcrito de la organización no encontrado',
    org_video_not_found: 'Vídeo no encontrado',
    canva: 'Hazlo desde Canva',
    canva_open: 'Haz clic aquí para abrir el editor de Canva.',
    pdf: 'PDF',
    txt: 'TEXTO',
    human: 'Premium',
    shared_file: 'Tu archivo se ha compartido correctamente.',
    error_shared_file:
      'Hubo un problema al compartir el archivo. Inténtalo de nuevo.',
    publish: 'Publicar',
    maze_scenes: 'Escenarios de MetaMaze',
    pexel_images: 'Imágenes de Pexel',
    group: 'Grupo',
    group_name: 'Nombre del grupo',
    select_group: 'Seleccionar grupo',
    search_maze: 'Buscar MetaMaze',
    hosts: 'Anfitriones',
    avg_score: 'Puntuación porcentual media',
    maze_report: 'Informe de Maze',
    maze_view: 'Vista de Maze',
    title_maze: 'MetaMaze',
    author: 'Autor',
    match: 'Coincidencia de ruta',
    preview_mazeTitle: 'Título: ',
    other: 'Otro',
    total: 'TOTAL',
    report_course: 'CURSO',
    report_courses: 'CURSOS',
    report_event: 'EVENTO',
    report_events: 'EVENTOS',
    report_maze: 'MAZE',
    report_personalize_learning: 'APRENDIZAJE PERSONALIZADO',
    report_live_assessment: 'EVALUACIÓN EN DIRECTO',
    report_live_assessments: 'EVALUACIONES EN DIRECTO',
    report_skill_journey: 'RECORRIDO DE HABILIDADES',
    skill_journey: 'Recorrido de habilidades',
    skill_journeys: 'Recorridos de habilidades',
    date: 'FECHA: ',
    search_people: 'Buscar personas',
    passed: 'APROBADO',
    failed: 'SUSPENDIDO',
    item: 'ELEMENTO',
    type: 'TIPO',
    minimum_pass_score: 'PUNTUACIÓN MÍNIMA PARA APROBAR',
    resources_count: 'CANTIDAD DE RECURSOS',
    back: 'VOLVER',
    resources: 'RECURSOS',
    time_spent: 'TIEMPO EMPLEADO (MINUTOS)',
    detail: 'DETALLE',
    watched_time_mins: 'TIEMPO VISTO (MINUTOS)',
    personalize_learning: 'Aprendizaje personalizado',
    result: 'Resultado',
    assessment_title: 'Título',
    marketPlace_graph: 'Gráfico del Marketplace',
    attachments: 'Archivos adjuntos adicionales',
    new_scorm_course: 'Subir un nuevo curso SCORM',
    upload_scorm_course: 'Subir curso SCORM',
    new_maze: 'Crear un nuevo MetaMaze',
    new_skill_journey: 'Crear un Recorrido de Habilidades',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Recorrido de Habilidades',
    new_discussion_room: 'Crear un nuevo pódcast',
    title: '¿Qué quieres hacer hoy?',
    build_course: 'Crear mi curso',
    live_broadcast: 'Transmisión en directo',
    invite_users: 'Invitar usuarios a mi organización',
    build_voice_over: 'Crear mi voz en off',
    view_reports: 'Ver informes',
    upload_media: 'Subir mis contenidos o trabajos y compartirlos',
    main_menu: 'Menú principal',
    get_started: 'EMPEZAR',
    search_group: 'Buscar grupo de la organización',
    ai_course: 'Curso de IA',
    search_user: 'Buscar nombre de la empresa',
    no_maze: 'Actualmente no hay MetaMaze disponibles.',
    conference_event_title: 'Eventos de conferencia',
    conference_event_subTitle: 'Eventos de conferencia finalizados',
    conference_event: 'Actualmente no hay eventos de conferencia.',
    no_skill: 'Actualmente no hay recorridos de habilidades.',
    no_podcast: 'Actualmente no hay pódcast.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Evaluaciones en directo anteriores',
    no_live_assessment: 'Actualmente no hay evaluaciones en directo.',
    enrolled_courses: 'Cursos',
    my_video_channel: 'Mis canales de vídeo',
    enrolled_liveEvents: 'Eventos en directo',
    sharebot: 'Sharebot',
    selected_language: 'Idioma seleccionado',
    shareSphere_game: 'Juego ShareSphere',
    maze: 'MetaMaze',
    skill: 'Recorrido de Habilidades',
    channel: 'Canal',
    order: 'Orden',
    is_record: 'Grabar',
    no_maze_found: 'No se encontró ningún MetaMaze.',
    maze_self_limit_reached:
      'Se ha alcanzado el límite de autoevaluaciones en MetaMaze.',
    metamaze_two_times: 'Ya has realizado este MetaMaze 2 veces.',
    metamaze_two_times_no_result:
      'Ya has realizado este MetaMaze 2 veces. Tu resultado no se registrará al completarlo más veces.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Puntuación mínima para aprobar',
    organization: 'Por favor, selecciona una organización',
    pass_score_mark: 'Introduce una puntuación entre 1 y 100',
    maze_cloning_success: '¡MetaMaze "<0/>" se ha clonado correctamente!',
    create_certificate: 'Crear un certificado',
    create_badge: 'Crear una insignia',
    certificate_added: 'Certificado añadido.',
    badge_added: 'Insignia añadida.',
    certificate_warning:
      '¡No podrás editar el certificado/insignia una vez publicado!',
    created_course_plan:
      'Edita y publica tu curso creado y programa eventos en directo',
    market_place_space: 'Mercado',
    select_course_language: 'Seleccionar idioma (opcional)',
    select_language: 'Seleccionar idioma',
    file_upload: 'Subida de archivos',
    text: 'Escribe el texto aquí…',
    attempts_count: 'Número de intentos permitidos al usuario',
    no_of_people_placeholder: 'Número de personas',
    back_to_maze: 'Volver al escenario de MetaMaze',
    edit_maze: 'Editar Maze',
    wait: 'Espera...',
    retry: 'Reintentar',
    publish_scorm_course: 'Publicar tu curso SCORM',
    publish_maze: 'Publicar tu MetaMaze',
    import: 'Importar elementos',
    answer_correct: 'Elige la respuesta correcta',
    author_name: 'Introduce el nombre del autor',
    select_category: 'Selecciona una categoría',
    course_outline: 'Introduce el esquema del curso',
    course_obj: 'Introduce los objetivos del curso',
    course_description: 'Introduce la descripción del curso',
    maze_outline: 'Introduce el esquema del laberinto',
    maze_obj: 'Introduce los objetivos del laberinto',
    maze_description: 'Introduce la descripción del laberinto',
    lessons: 'Introduce el número de lecciones',
    user_email_require: 'Se requiere el correo electrónico del usuario',
    team_size: 'Se requiere el tamaño del equipo',
    enter_price: 'Introduce un precio (5 o más)',
    input_title_maze: 'Introduce el título del laberinto',
    trainer_bio: 'Introduce la biografía del formador',
    trainer_linkedin: 'Introduce el LinkedIn del formador',
    error_video: 'Introduce el número de vídeos',
    input_video_link: 'Introduce el enlace del vídeo',
    number_of_video: 'número de vídeos',
    number_of_lessions: 'número de lecciones',
    no_of_people_in_conference: '¿Cuántas personas hay en la conferencia?',
    transcribe_settings: 'Configuración de transcripción',
    transcribe: 'Transcribir',
    cloning_maze: 'Clonando MetaMaze...',
    id_number: 'Número de identificación',
    timezone: 'Zona horaria',
    edit_maze: 'Editar',
    delete_maze: 'Eliminar',
    view_maze: 'Ver',
    create_metamaze: 'Crear un MetaMaze',
    metamaze_scenario: 'Escenario de MetaMaze',
    publish_metamaze: 'Configuración de publicación',
    search_result: 'Resultados de búsqueda:',
    search_for: 'Buscar',
    search_no_result: '- ¡No hay resultados disponibles!',
    channel_no_available: '¡No hay canales disponibles!',
    this_card: 'Esta es una tarjeta',
    course_no_available: '¡No hay cursos disponibles!',
    exit_fullscreen: 'Salir de pantalla completa',
    bg_image: 'Imagen de fondo',
    introduction: 'Introducción',
    summary: 'Resumen',
    generate_introduction: 'Generar introducción',
    generate_summary: 'Generar resumen',
    bullet_points: 'Puntos clave',
    title_simulation: 'Introduce el nombre de la simulación',
    view_generated_images: 'Ver imágenes generadas',
    image_transparency: 'Transparencia de imagen',
    template_bg_color: 'Color de fondo de la plantilla',
    select_template_layout: 'Selecciona un diseño de plantilla',
    reload_template: '(Recargar plantillas)',
    are_you_sure_want_close: '¿Estás seguro de que deseas cerrar?',
    all_your_changes_will_be_lost: 'Se perderán todos tus cambios.',
    please_checked_before_generated_video:
      'Por favor, confirma que se han marcado todas las condiciones antes de generar un vídeo.',
    voice_must_be_selected: 'Se debe seleccionar una voz',
    avatar_must_be_selected: 'Se debe seleccionar una imagen de avatar.',
    maximum_five_slides_try_again:
      'Error al extraer imágenes del archivo. Asegúrate de que el archivo tiene un máximo de 5 diapositivas y notas en cada una. ¡Inténtalo de nuevo!',
    back_to_upload: 'Volver a la subida',
    uploading_file_to_server: 'Subiendo tu archivo al servidor',
    extracting_images_from_your_file: 'Extrayendo imágenes de tu archivo',
    upload_your_ppt_or_drag:
      'Sube tu archivo de presentación (.PPTX) o arrástralo aquí.',
    maximum_five_slides_error:
      'Asegúrate de que tu archivo PowerPoint contiene un máximo de 5 diapositivas y que cada una incluye notas. De lo contrario, se producirá un error.',
    number_of_questions_generated: 'Número de preguntas a generar',
    quiz_page_this_cannot_be_done:
      '¿Estás seguro de que deseas añadir el cuestionario a esta página? Esto no se puede deshacer.',
    confirm_selection: 'Confirmar selección',
    select_quiz_page: 'Seleccionar página del cuestionario',
    lesson_do_you_want_add_this_quiz:
      '¿En qué parte de la lección deseas añadir este cuestionario?',
    beginning_of_lesson: 'Al inicio de la lección',
    end_of_lesson: 'Al final de la lección',
    currently_active_page: 'Página actualmente activa',
    finish: 'Finalizar',
    upload_selection_file: 'Subir archivo de sección',
    general_quiz: 'Cuestionario general',
    manage_sequence: 'Gestionar secuencia',
    save_sequence: 'Guardar secuencia',
    new: 'Nuevo',
    in_progress: 'En curso',
    recommended_course: 'Curso recomendado',
    up_coming: 'Próximo',
    past_live: 'Transmisiones pasadas',
    input_your_channel_name: '¡Introduce el nombre de tu canal!',
    organization_place: 'Mercado de la organización',
    marketplace_report: 'Informe del mercado',
    story_writing: 'Redacción de historias',
    Ai_quiz: 'Cuestionario IA',
    generate_quiz: 'Generar cuestionario',
    create_story: 'Crear historia',
    change_layout_page: 'Vas a cambiar el diseño de esta página.',
    change_layout_message:
      'Ten en cuenta que solo se conservarán el texto, las imágenes, el fondo y el logotipo. Todos los demás elementos se eliminarán.',
    reviews: 'Reseñas',
    tab_attachments: 'Adjuntos',
    zoom_in: 'Acercar',
    zoom_out: 'Alejar',
    zoom_reset: 'Restablecer zoom',
    no_attachment: 'No hay archivos adjuntos.',
    select_upload_simulation: 'Selecciona o sube una simulación.',
    quiz_updated_successfully: '¡Cuestionario actualizado con éxito!',
    quizes: 'Cuestionarios',
    trivia: 'Curiosidades',
    closing: 'Cerrando...',
    products: 'Productos',
    ask_questions: 'Haz una pregunta aquí...',
    course_information: 'Información del curso',
    course_assistance: 'Asistencia para el creador del curso',
    go_back: 'Volver',
    ai_generate_content_progress: 'Progreso generando contenido',
    view_generate_content: 'Ver contenido generado',
    generate_error: '¡Error al generar!',
    confirm_creating_course:
      '¿Deseas confirmar la creación del curso con este contenido?',
    generate_content_automatically:
      'Esto añadirá automáticamente todo el contenido generado como lecciones y páginas a tu curso.',
    quiz_created_successfully: '¡Cuestionario creado con éxito!',
    create_quiz: 'Crear cuestionario',
    quiz_setting: 'Configuración del cuestionario',
    please_fill_quiz_setting:
      '* Por favor, completa todos los campos en la configuración del cuestionario',
    question_list: 'Lista de preguntas',
    add_quiz_to_page: 'Añadir cuestionario a la página',
    form_create_question: 'Formulario para crear pregunta',
    user_information_updated: '¡Información del usuario actualizada!',
    your_stripe_activete_to_continue:
      'Tu cuenta de Stripe está inactiva. Conéctala o actívala para continuar.',
    connect_tripe: 'Conectar Stripe',
    certificate_sent_sucessfully:
      'Certificado enviado a tu correo electrónico con éxito.',
    error_try_again: 'Error. ¡Inténtalo de nuevo!',
    error_delete_channel: 'Error al eliminar el canal.',
    error_update_sub: 'Error al actualizar la suscripción.',
    end_time_cannot_start:
      'La hora de finalización no puede ser anterior a la de inicio.',
    start_date_time_interval: '¡Se requiere fecha y hora de inicio!',
    podcast_updated_successful: 'Podcast actualizado con éxito.',
    podcast_created_successful: 'Podcast creado con éxito.',
    podcast_published_successful: 'Podcast publicado con éxito.',
    podcast_cover_updated: 'Portada del podcast actualizada.',
    new_podcast_details:
      'Se creará un nuevo podcast con los nuevos datos introducidos a partir del actual.',
    current_update_podcast: 'Actualizar el podcast actual, música e historias.',
    create_new_podcast: 'Crear nuevo podcast',
    publish_podcast_public_view: 'Publicar podcast para vista pública.',
    only_allowed_twenty_five_email: 'Solo se permiten 25 correos electrónicos.',
    only_allowed_five_email: 'Solo se permiten 5 correos electrónicos.',
    cover_is_required: 'Se requiere portada.',
    topic_is_required: 'Se requiere tema.',
    delete_schedule: 'Eliminar programación',
    make_as_coaching: 'Marcar como disponibilidad para coaching',
    manage_category: 'Gestionar categoría',
    threshold: 'Umbral',
    threshold_popup:
      'Valor umbral en porcentaje (%), el valor a partir del cual se activa la recomendación para la categoría indicada.',
    list_of_catagory: 'Lista de categorías',
    category_name: 'Nombre de la categoría',
    category_threshold: 'Umbral de la categoría',
    play_game: 'Jugar',
    switching_organization: 'Cambiando de organización...',
    coaching_session: 'Sesión de coaching',
    required_channel_id: '¡Se requiere ID del canal!',
    error_occured_try_again: 'Ha ocurrido un error. ¡Inténtalo de nuevo!',
    please_complete_marketplace_form:
      '¡Por favor, completa el formulario del marketplace!',
    upload_file_corrupt: 'El archivo subido está dañado.',
    course_not_published: '¡El curso aún no ha sido publicado!',
    error_request: 'Error en la solicitud. ¡Por favor, inténtalo de nuevo!',
    skill_request: '¡Por favor, completa los campos obligatorios!',
    error_occured: 'Ha ocurrido un error. ¡Inténtalo de nuevo!',
    show_time: 'Mostrar hora',
    start_time: 'Hora de inicio',
    end_time: 'Hora de finalización',
    room_name: 'Nombre del podcast',
    add_guest_speaker: 'Añadir ponente invitado',
    cover_picture: 'Imagen de portada',
    guest_speaker: 'Ponente invitado',
    see_more: 'Ver más',
    see_less: 'Ver menos',
    background: 'Fondo',
    icon: 'Icono',
    icon_size: 'Tamaño del icono',
    icon_color: 'Color del icono',
    only_text: 'Solo texto',
    change_bg: 'Cambiar color de fondo',
    bg_color: 'Color de fondo',
    font_size: 'Tamaño de fuente',
    normal: 'Normal',
    change_color: 'Cambiar color de texto',
    slant_text: 'Texto inclinado',
    text_radius: 'Radio del texto',
    vertical_align: 'Alineación vertical',
    horizontal_align: 'Alineación horizontal',
    change_icon_color: 'Cambiar color del icono',
    upload_icon: 'Subir icono',
    upload_signature: 'Subir firma',
    add_another_sign: 'Añadir otra firma',
    name_badges: 'Nombre de las insignias',
    should_less_150: 'debe tener 150 caracteres o menos',
    your_badge: 'Tu insignia',
    do_you_want_delete_badge:
      '¿Estás seguro de que deseas eliminar esta insignia?',
    do_you_want_delete_cert:
      '¿Estás seguro de que deseas eliminar este certificado?',
    upload_logo: 'Subir logotipo',
    name_of_cert: 'Nombre del certificado',
    upload_cert: 'Actualizar certificado',
    your_cert: 'Tu certificado',
    translate_to: 'Traducir a',
    select_file_attach: 'Seleccionar archivo para adjuntar',
    certificate: 'Certificado',
    badge: 'Insignia',
    publish_options: 'Opciones de publicación',
    publish_skills_journey: 'Publicar recorrido de habilidades',
    videos: 'Vídeos',
    generate_ai_video:
      'El proceso de generación del vídeo puede tardar. Recibirás un correo electrónico cuando se complete.',
    trainer_information: 'Información del formador',
    promotional_video_link: 'Enlace del vídeo promocional',
    please_select: 'Por favor selecciona',
    image_name: 'Nombre de la imagen:',
    image_size: 'Tamaño de la imagen:',
    charecters_fifteen_less: '15 caracteres o menos',
    leadership: 'Liderazgo',
    text_arc: 'Arco de texto',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    badge_history: 'Historial de insignias',
    templates: 'Plantillas',
    sign: 'Firma',
    logo: 'Logotipo',
    certificate_history: 'Historial de certificados',
    please_wait: 'Por favor, espera...',
    information: 'Información',
    support_five_thousand_live_event:
      'Admite hasta 5000 participantes en el evento',
    support_ten_live_event: 'Admite hasta 10 participantes en vídeo en directo',
    we_will_back_participant:
      'Volveremos con el evento con acceso para muchos más participantes.',
    course_objectives: 'Objetivos del curso',
    course_outlines: 'Temario del curso',
    price_dollor: 'precio (USD)',
    not_completed: 'No completado',
    enable_marketplace: 'Habilitar Marketplace',
    enable_course_ai: 'Habilitar creación de curso con IA',
    enable_report_to_admin: 'Habilitar informes para el administrador',
    enable_white_label: 'Habilitar Marca Blanca',
    enable_eleven_labs_for_maze_play: 'Habilitar Elevenlabs para Maze Play',
    enable_eleven_labs_for_maze_play_cloned:
      'Habilitar voces clonadas de Elevenlabs',
    simulation_quiz: 'Cuestionario de simulación',
    bg_color_setting: 'Configuración del color de fondo',
    color_preview: 'Vista previa del color',
    choose_new_color: 'Elegir nuevo color',
    remove_color: 'Eliminar color',
    apply_color: 'Aplicar color',
    elemeent_in_a_sceenario_page:
      'No puedes añadir otro elemento en una página de escenario. Prueba en otra página o elimina el escenario primero.',
    no_data_found: 'No se encontraron datos.',
    references: 'Referencias',
    open_file: 'Abrir archivo',
    showing_result: 'Mostrando resultados:',
    fiften_day_free_trail: 'Prueba gratuita de 15 días',
    your_browser_does_not_support:
      'Tu navegador no soporta el elemento de audio.',
    podcast_desc: 'Descripción del pódcast',
    input_podcast_desc: 'Por favor, introduce la descripción del pódcast',
    podcast_obj: 'Objetivos del pódcast',
    input_podcast_obj: 'Por favor, introduce los objetivos del pódcast',
    podcast_outline: 'Esquema del pódcast',
    input_podcast_outline: 'Por favor, introduce el esquema del pódcast',
    add_file: 'Añadir archivo',
    generate_podcast_audio: 'Generar audio del pódcast',
    generate_uploaded_file_input_parameter:
      'Genera contenido relativo a los archivos subidos por el usuario con los parámetros introducidos.',
    go_backe_generation_state: 'Volver al estado de generación de contenido.',
    create_ai_powered_podcast:
      'Crea un episodio de pódcast impulsado por IA con audio generado.',
    generate_voice_for_all_podcast:
      'Por favor, genera la voz para todos los episodios del pódcast',
    create_podcast_episode: 'Crear episodio del pódcast',
    voice_name: 'Nombre de la voz',
    input_custom_name: '¡Por favor, introduce un nombre personalizado!',
    enter_custom_name: 'Introduce el nombre de voz personalizado',
    upload_complete: 'carga completada',
    uploading_in_progress: 'cargando...',
    podcast_stream_content: 'Contenido del pódcast en streaming',
    upload_podcast_cover: '¡Por favor, sube la portada del pódcast!',
    enter_podcast_name: '¡Por favor, introduce el nombre del pódcast!',
    podcast_topic: 'Tema del pódcast',
    enter_podcast_topic: '¡Por favor, introduce el tema del pódcast!',
    enter_podcast_desc: '¡Por favor, introduce la descripción del pódcast!',
    number_of_speaker: 'Número de hablantes',
    select_the_number_of_speaker:
      '¡Por favor, selecciona el número de hablantes!',
    number_of_episode: 'Número de episodios',
    input_number_of_episode: '¡Por favor, introduce el número de episodios!',
    podcast_length: 'Duración del pódcast',
    select_the_podcast_length:
      '¡Por favor, selecciona la duración del pódcast!',
    short_podcast: 'Corto (5–10 min)',
    medium_podcast: 'Medio (15–18 min)',
    long_podcast: 'Largo (18+ min)',
    name_of_host: 'Nombre del presentador',
    enter_host_name: '¡Por favor, introduce el nombre del presentador!',
    guest_name: 'Nombre de los invitados',
    enter_guest_name: '¡Por favor, introduce el nombre del invitado!',
    choose_speaker_tone: 'Selecciona el tono del hablante',
    enter_speaker_tone: '¡Por favor, selecciona el tono del pódcast!',
    informal: 'Informal',
    formal: 'Formal',
    serious: 'Serio',
    light_humor: 'Humor ligero',
    casual: 'Casual',
    select_content_source: 'Selecciona la fuente del contenido',
    from_internet: 'De Internet',
    upload_pdf_internet: 'Sube un PDF o documento interno',
    note: 'Nota:',
    podcast_content_will_be_automatically_generated:
      'El contenido del pódcast se generará automáticamente usando fuentes confiables de Internet.',
    upload_or_select_file: '¡Por favor, sube o selecciona archivo(s)!',
    podcast_eposode_title: 'Título del episodio del pódcast',
    enter_podcast_title: '¡Por favor, introduce el título del episodio!',
    podcast_episode_des: 'Descripción del episodio del pódcast',
    enter_podcast_episode_des:
      '¡Por favor, introduce la descripción del episodio!',
    voice: 'Voz',
    music: 'Música',
    select_music: 'Seleccionar música',
    play_the_music: 'Reproducir música',
    stop_the_music: 'Detener música',
    context: 'Contexto',
    generate_audio_content_selected_voice:
      'Esto generará el audio del contenido según las voces seleccionadas.',
    required_field_before_submitting:
      'Por favor, completa todos los campos obligatorios antes de enviar.',
    regenerate_voice: 'Regenerar voz',
    generate_voice: 'Generar voz',
    your_browser_does_not_suppot:
      'Tu navegador no admite el elemento de audio.',
    are_sure_leave_podcast: '¿Seguro que quieres salir del pódcast?',
    broadcast_ongoing:
      'La emisión está en curso. ¿Realmente quieres salir de esta página?',
    brodcaster_unavailable: 'Actualmente el emisor no está disponible.',
    setting_calender_for_booking: 'Configurando calendario para la reserva',
    add_calender: 'Añadir calendario',
    waiting_join_host: 'Esperando a que se una el presentador...',
    no_reviews_found: 'No se han encontrado valoraciones.',
    rated_already: 'Ya has valorado este evento en directo.',
    downlink_png: 'descargar_png',
    downlink_jpg: 'descargar_jpg',
    donwload_file_format:
      'Selecciona el formato de archivo que deseas descargar.',
    crashed_event:
      'Este evento ha fallado. Necesitas crear uno nuevo. Disculpa las molestias.',
    prompt: 'Prompt:',
    generated_image: '🚀 Generando tu imagen... Por favor, espera.',
    download_add: 'Descargar todo',
    setting_generator: 'Configuración del generador',
    enter_image_prompt: 'Introduce un prompt de imagen',
    image_prompt: 'Introduce tu prompt de imagen',
    negative_prompt: 'Prompt negativo',
    negative_image_prompt: 'Introduce tu prompt negativo de imagen',
    number_output: 'Número de resultados',
    enter_number_output: 'Introduce el número de resultados',
    image_style: 'Selecciona el estilo de imagen',
    output_format: 'Formato de salida',
    seeds: 'Semillas',
    enter_seeds: 'Introduce el número de semillas',
    performance_mode: 'Modo de rendimiento',
    quality: 'Calidad',
    speed: 'Velocidad',
    balanced: 'Equilibrado',
    guidance_scale: 'Escala de guía',
    enter_guidance: 'Introduce la escala de guía',
    select_image: 'Selecciona imagen.',
    image_prmt: 'Prompt de imagen',
    generate_image_list_empty: 'La lista de imágenes generadas está vacía.',
    knowledge_center_tooltrip_des:
      'Obtén respuestas concisas y precisas en contexto sobre una amplia gama de temas. Las respuestas provienen de información general de Internet usando un modelo de IA entrenado con textos diversos.',
    contexts: 'Contextos',
    ai_processing_video_sharebot:
      'El procesamiento del vídeo por IA llevará unas 24 horas en completarse y se reflejará en Sharebot.',
    remove_sharebot_video:
      'Si deseas eliminar la referencia del vídeo en Sharebot, por favor elimina también su transcripción correspondiente.',
    remove_sharebot_video_audio:
      'Al eliminar la transcripción se eliminará la referencia al vídeo/audio en Sharebot, aunque el vídeo seguirá estando en la biblioteca de medios o canal.',
    monthly_live_stream:
      'Para cambiar tu límite mensual de streaming en directo, contacta con',
    monthly_transcribe_limit:
      'Para cambiar tu límite mensual de transcripción, contacta con',
    must_be_one_to_three_hundred: 'Debe estar entre 1 y 300 minutos.',
    all_field_required: 'Todos los campos son obligatorios.',
    duration_minute: 'Duración (máximo 300 minutos)',
    gender: 'Género',
    select_gender: 'Selecciona el género',
    accent: 'Acento',
    select_accent: 'Selecciona el acento',
    create_voice: 'Crear voz',
    enter_voice_name: 'Introduce el nombre de la voz',
    select_voice_gender: 'Por favor, selecciona el género de la voz',
    upload_voice: 'Sube tu voz',
    upload_voice_mp_three: 'Sube tu voz (.mp3)',
    cloned_voice: 'Voces clonadas',
    voice_type: 'Tipo de voz',
    select_voice_type: 'Selecciona el tipo de voz',
    sharelook_stand: 'Estándar',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Personalizada (clonación de voz)',
    create_auto_flow: 'Crear flujo automático',
    how_many_layers: '¿Cuántas capas?',
    verify_selection: 'Verificar selección',
    uploaded_successful: 'Subida realizada con éxito',
    upload_failed: 'Error al subir',
    upload_only_five_mb: 'Subir contenido (archivos PDF, máx. 5)',
    docs_from_org_library: 'Usar documento de la biblioteca de la organización',
    failed_maze_generate:
      'No se pudo generar el laberinto. Por favor, inténtalo de nuevo.',
    generate_metamaze: 'Generando MetaMaze...',
    metamaze_being_generated:
      'Tu MetaMaze se está generando. Se te notificará por correo electrónico una vez finalizado el proceso.',
    metamaze_generate_successfully: '¡MetaMaze generado con éxito!',
    metamaze_with_proceed: 'Ahora puedes continuar con el MetaMaze.',
    ai_metamaze_generate: 'Generación de MetaMaze con IA',
    what_kind_maze_create: '¿Qué tipo de laberinto deseas crear?',
    manual_metamaze_creation: 'Creación manual de MetaMaze',
    manually_maze_customizing_scnario:
      'Crea un laberinto manualmente personalizando el escenario y el árbol de opciones',
    maze_ai_generated: 'Generar laberinto automáticamente con IA',
    unmark_deadend: 'Desmarcar como callejón sin salida',
    mark_deadend: 'Marcar como callejón sin salida',
    select_multiple_image_for_scenario:
      'Puedes seleccionar múltiples imágenes para el escenario.',
    select_your_image: 'Tus imágenes seleccionadas',
    click_to_preview: 'Haz clic para previsualizar',
    are_you_sure_delete_image:
      '¿Estás seguro de que quieres eliminar esta imagen?',
    select_image_from_library: 'Selecciona imagen de la biblioteca multimedia',
    uploading_video: 'Subiendo vídeo...',
    tree_node_type: 'Tipo de nodo del árbol',
    correct_option_scenario: 'Opción correcta o escenario',
    incorrect_option: 'Opción incorrecta',
    option_scenario_without_text: 'Opción o escenario sin texto',
    dead_end: 'Callejón sin salida (borde rojo)',
    correct_path: 'Camino correcto',
    incorrect_path_not_selected_correct_option_path:
      'Camino incorrecto / Camino donde no se seleccionó la opción correcta.',
    double_click_on_tree_node:
      'Al hacer doble clic en un nodo del árbol, el editor de texto se desplazará automáticamente para mostrar el contenido de ese nodo específico.',
    add_scenario: 'Añadir escenario',
    add_option: 'Añadir opción',
    an_error_occured: 'Ha ocurrido un error:',
    download_summary: 'Descargar resumen',
    step_wise_analysis: 'Análisis paso a paso',
    step: 'Paso',
    upload_csv_file: 'Subir archivo CSV',
    download_template_to_import: 'Descargar plantilla de ejemplo para importar',
    please_input_email: 'Por favor, introduce el correo electrónico.',
    email_at_least_three_characters:
      'El correo electrónico debe tener al menos 3 caracteres.',
    email_cannot_be_empty: 'El correo electrónico no puede estar vacío.',
    input_email_in_new_line:
      'Introduce los correos electrónicos (uno por línea)',
    role: 'Rol',
    select_role: 'Por favor, selecciona un rol',
    select_group: 'Por favor, selecciona un grupo',
    identification_number: 'Número de identificación (opcional)',
    add_identification_number: 'Por favor, añade un número de identificación',
    pie_chart_of_all_categories:
      'Gráfico circular de todas las categorías según su uso en Sharelook.',
    total_sharesphere_question_answered_by_users:
      'Total de preguntas de ShareSphere respondidas por los usuarios en la organización actual, con sus respectivas categorías y resultados de éxito y fallo.',
    voice_style_over_the_text:
      'Donde puedes usar muchos estilos de voz sobre el texto que escribas. Bla bla bla. Lorem Ipsum es simplemente texto ficticio de la industria de la impresión y la composición tipográfica. Ha sido el texto de relleno estándar desde el siglo XVI.',
    input_your_question: '¡Por favor, introduce tu pregunta!',
    make_me_sales_manager:
      'Ej: ¿Qué puede hacer que me convierta en gerente de ventas?',
    enter_the_number_relevant_document:
      'Introduce el número de documentos relevantes',
    please_wait_loading_result: 'Por favor, espera, cargando resultados...',
    no_result_found:
      'No se encontraron resultados. Intenta hacer otra pregunta',
    browser_doesnot_support_iframes: 'Tu navegador no admite iframes',
    total_duration: 'Duración total',
    number_of_messages: 'Número de mensajes',
    search_result: 'Resultados de búsqueda',
    count_result: '(1244 resultados)',
    your_other_interests: 'Tus otros intereses',
    your_total_score: 'Tu puntuación total',
    add_a_question: '+añadir una pregunta',
    travia_question_empty: 'La lista de preguntas de Travia está vacía.',
    video_generation_is_on_queue: '¡Tu vídeo está en cola para generarse!',
    checking_video_status: 'Comprobando el estado del vídeo...',
    total_quizzes: 'Cuestionarios totales',
    number_of_votes: 'Número de votos',
    total_events: 'Eventos totales',
    number_of_rates: 'Número de valoraciones',
    number_of_likes: 'Número de "me gusta"',
    all_courses: 'Todos los cursos',
    total_questions: 'Preguntas totales',
    no_skill_journey: '¡No hay trayectorias de habilidades disponibles!',
    search_no_results: '- ¡sin resultados disponibles!',
    no_image_generated: '¡No se han generado imágenes!',
    all_topic_in_this_lesson:
      'Se eliminarán todos los temas de esta lección. Esta acción no se puede deshacer.',
    content_has_been_generated: 'Se ha generado contenido para este tema.',
    update_course_template: 'Actualizar plantilla del curso',
    add_course_template: 'Añadir plantilla del curso',
    create_course_now: 'Crear curso ahora',
    preview_course: 'Previsualizar curso',
    layout: 'Diseño',
    import_from_youtube: 'Importar desde YouTube',
    my_media_library: 'Mi biblioteca multimedia',
    bg_added: 'Fondo añadido',
    add_bg: 'Añadir fondo',
    booked_schedule: 'Horario reservado',
    add_schedule: 'Añadir horario',
    are_you_delete_schedule:
      '¿Estás seguro de que deseas eliminar este horario?',
    add_task: 'Añadir tarea',
    update_calender: 'Actualizar calendario',
    manage_cookies: 'Gestionar cookies',
    cookie_banner_text:
      'Utilizamos cookies para mejorar su experiencia de navegación, analizar el tráfico del sitio web y personalizar el contenido. Su privacidad es importante para nosotros.',
    accept_all_cookies: 'Aceptar todas las cookies',
    reject_all: 'Rechazar todas',
    customize: 'Personalizar',
    cookie_preferences_title:
      'Preferencias de cookies y configuración de privacidad',
    privacy_subtitle:
      'Su privacidad es importante para nosotros. Elija qué cookies acepta. Puede cambiar esta configuración en cualquier momento.',
    save_choices: 'Guardar mis elecciones',
    strictly_necessary: 'Estríctamente necesarias',
    strictly_necessary_desc:
      'Estas cookies son esenciales para que el sitio web funcione correctamente. Permiten funciones básicas como navegación de páginas, envío de formularios y acceso a áreas seguras. El sitio no puede funcionar correctamente sin ellas.',
    analytics_performance: 'Analítica y rendimiento',
    analytics_performance_desc:
      'Estas cookies nos ayudan a entender cómo interactúan los visitantes con nuestro sitio web mediante la recopilación y el informe de información de forma anónima. Esto nos ayuda a mejorar el rendimiento del sitio y la experiencia del usuario.',
    advertising_marketing: 'Publicidad y marketing',
    advertising_marketing_desc:
      'Estas cookies se utilizan para que los mensajes publicitarios sean más relevantes para usted. Evitan que el mismo anuncio aparezca continuamente y garantizan que los anuncios se muestren correctamente para los anunciantes.',
    tracking_social: 'Seguimiento y redes sociales',
    tracking_social_desc:
      'Estas cookies permiten funcionalidades mejoradas y personalización, como funciones de redes sociales y contenido personalizado. Pueden ser configuradas por nosotros o por proveedores externos.',
    functional: 'Funcionales',
    functional_desc:
      'Estas cookies permiten funcionalidades avanzadas como soporte de chat, ayuda en vivo y otras funciones interactivas que mejoran su experiencia en el sitio web.',
    your_rights: 'Sus derechos:',
    rights_description:
      'Puede retirar su consentimiento en cualquier momento, acceder a sus datos o solicitar su eliminación en cualquier momento.',
    withdraw_consent: 'Retirar todo el consentimiento',

    how_many_options: 'Cuántas opciones',
    add_content: 'Agregar contenido',
    downloads_center: 'Centro de descargas',
    sharelook_help_center: 'Centro de ayuda de Sharelook',
    channel_outline: 'Esquema del canal',
    channel_objectives: 'Objetivos del canal',
    no_sop_available: 'No hay lista de SOP disponible.',
    generate_world_summary: 'Generar escenario',
    world_scenario: 'Escenario del mundo real',
    drag_icon_hint: 'Consejo: Arrastre el icono sobre el lienzo para colocarlo',
    drag_text_hint: 'Consejo: Arrastre el texto sobre el lienzo para colocarlo',
    edit_badge: 'Editar insignia',
    create_new_badge: 'Nueva insignia',
    select_video_preview: 'Seleccione un vídeo para previsualizar',
    certificate_title_required: 'Se requiere título del certificado',
    discard_changes: 'Descartar cambios',
    edit_certificate: 'Editar certificado',
    add_another_logo: 'Agregar otro logotipo',
    optional: 'Opcional',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Crear una nueva misión',
    quest_filter_title: 'Misión',
    sharelook_assistance: 'Asistencia de Sharelook',
    upload_scorm_zip: 'Subir archivo Scorm Zip',
    only_letters_numbers_space_dot_allowed:
      '¡Solo se permiten letras, números, espacios y puntos!',
    video_playing: 'Reproduciendo',
    course_price_message:
      '*El curso solo se publicará para usuarios dentro de la organización y no se puede revender en el mercado.',
    lesson_must_be_positive: 'El número de lecciones debe ser mayor que 1',
    btn_proceed: 'Continuar',
    rule_select_music: 'Por favor seleccione música',
    course_info: 'Información del curso',
    content_selection: 'Selección de contenido',
    course_content_source: 'Fuente de contenido del curso',
    choose_how_to_source: 'Elija cómo obtener contenido para este curso:',
    automatic_selection: 'Selección automática',
    system_will_automatically_select_relavant_documents:
      'El sistema seleccionará automáticamente documentos relevantes de su biblioteca',
    manual_selection: 'Selección manual',
    choose_specific_documents_from_your_library:
      'Elija documentos específicos de su biblioteca',
    upload_files: 'Subir archivos',
    upload_new_documents:
      'Subir nuevos documentos (PDF, DOC, DOCX, PPT, PPTX, TXT) - Máximo 5 archivos',
    file: 'archivo',
    ready_to_upload: 'listo para subir',
    clear_all: 'Borrar todo',
    confirm_course_wide_premiew: 'Confirmar vista previa de todo el curso',
    generate_course_preview: 'Generar vista previa del curso',
    instructions_across_the_course_to_generate:
      'Aplicaremos sus instrucciones en todo el curso para generar una vista previa. Revise todo primero y luego decida si desea mantener o descartar los cambios.',
    instruction_to_preview_course_wide:
      'Instrucciones para vista previa del curso completo:',
    edit_content: 'Editar contenido',
    manage_course_template: 'Gestionar plantilla del curso',
    undo: 'Deshacer',
    apply_changes: 'Aplicar cambios',
    characters: 'caracteres',
    apply_all: 'Aplicar todo',
    apply_to_all: 'Aplicar a todo',
    use_this_content: 'Usar este contenido',
    original: 'Original',
    edited: 'Editado',
    edited_content_preview: 'Vista previa del contenido editado',
    apply_edits_to_all_topices: '¿Aplicar ediciones a todos los temas?',
    current_editing_instructions_across_the_whole_course:
      'Esto aplicará sus instrucciones actuales en todo el curso. Puede revisar la vista previa combinada antes de guardar.',
    edit_content_instructions: 'Instrucciones de edición de contenido',
    generate_content_for_this_topic_instruction:
      'Generar contenido para este tema utilizando sus instrucciones',
    descrip_edit_content:
      'Describa cómo editar este contenido (por ejemplo, resumir, simplificar, reformular)',
    try_short_clear_direcctives:
      'Pruebe directivas cortas y claras. Ejemplos: “reducir a 100 palabras, mantener puntos clave”, “simplificar lenguaje”, “hacer más conciso y eliminar relleno”.',
    we_preserve_the_core_meaning:
      'Preservamos el significado principal al aplicar sus instrucciones.',
    feedback_optional: 'Comentarios (Opcional)',
    write_your_feedback_here: 'Escriba sus comentarios aquí',
    from_web: 'Desde web',
    from_desktop: 'Desde escritorio',
    pleae_wait_processing: 'Por favor, espere mientras se procesa...',
    create_simulation_from_screen_capture:
      'Crear simulación desde captura de pantalla',
    sharelook_not_found: 'ShareLook no encontrado',
    sharelook_screen_capture_application_not_be_opened:
      'No se pudo abrir la aplicación ShareLook Screen Capture. Puede que no esté instalada en su ordenador.',
    download_sharelook: 'Descargar ShareLook',
    launch_sharelook_application: 'Abrir aplicación ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Esto abrirá la aplicación ShareLook para captura de pantalla.',
    sharelook_dosenot_open:
      'Si ShareLook no se abre, puede que no esté instalado en su ordenador.',
    open_sharelook: 'Abrir ShareLook',
    download_app: 'Descargar aplicación',
    background_image_setting: 'Configuración de imagen de fondo',
    current_image: 'Imagen actual',
    change_image: 'Cambiar imagen',
    remove_image: 'Eliminar imagen',
    no_background_image_selected:
      'No se ha seleccionado ninguna imagen de fondo',
    add_image: 'Agregar imagen',
    this_will_open_for_screen_recording:
      'Esto abrirá la aplicación ShareLook para grabación de pantalla.',
    ai_image_generation: 'Generación de imagen AI',
    image_edit: 'Editar imagen',
    text_to_image: 'Texto a imagen',
    output_gallary: 'Galería de resultados',
    instant_generation: 'Listo para generación instantánea',
    prompt_and_unleash_the_power: 'Introduzca su prompt y libere el poder',
    use_this_image: 'Usar esta imagen',
    error_generating: 'Error al generar.',
    generation_tips: 'Consejos de generación',
    detailed_descriptions_for_more_accurate_results:
      'Utilice descripciones detalladas para resultados más precisos',
    reference_image: 'Imagen de referencia',
    select_pixel_image: 'Seleccionar imagen de píxeles',
    max_mb: 'Máx. 50 MB',
    please_enter_text_to_appear_image:
      'Introduzca el texto que aparecerá en la imagen',
    enter_text_to_apear_in_the_image:
      'Introduzca el texto que aparecerá en la imagen',
    generate_image: 'Generar imagen',
    prompt_assistant: 'Asistente de prompt',
    generate_image_using_suggested_prompt:
      'Generar imagen usando el prompt sugerido',
    talk_to_ai_about_the_image_generate:
      'Hable con AI sobre la imagen que desea generar',
    ask_for_prompt_suggestions: 'Pedir sugerencias de prompt...',
    enter_a_search_term_to_find_stock_images:
      'Ingrese un término de búsqueda para encontrar imágenes de stock',
    choose_your_content_source: 'Elija su fuente de contenido:',
    upload_new_document_from_your_device:
      'Subir nuevos documentos desde su dispositivo',
    automatic_library_selection: 'Selección automática de biblioteca',
    system_automatically_selects_relevant_document:
      'El sistema selecciona automáticamente documentos relevantes',
    manual_library_selection: 'Selección manual de biblioteca',
    generate_content: 'Generar contenido',
    add_to_current_page: 'Agregar a la página actual',
    generate_bullet_points: 'Generar puntos clave',
    generating: 'Generando',
    this_may_take_a_few_moments: 'Esto puede tardar unos momentos',
    apply_to_page: 'Aplicar a la página',
    scenario_escription: 'Descripción del escenario:',
    feedback: 'Comentarios',
    form_mode: 'Modo de formulario',
    chat_mode: 'Modo de chat',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Esto generará una continuación de la historia seleccionada utilizando IA.',
    continue_this_story_question: '¿Continuar esta historia?',
    continue_this_story: 'Continuar esta historia',
    what_will_happen: 'Qué pasará:',
    the_ai_will_analyze_the_existing_story_content:
      'La IA analizará el contenido existente de la historia',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Genera una continuación natural que siga el mismo tono y estilo',
    create_new_content_that_build_upon_the_current_narrative:
      'Crea nuevo contenido que se base en la narrativa actual',
    this_process_may_take_a_few_moments_to_complete:
      'Este proceso puede tardar unos momentos en completarse.',
    no_existing_stories_found_for_this_course:
      'No se han encontrado historias existentes para este curso.',
    create_your_first_story: 'Crea tu primera historia',
    existing_stories: 'Historias existentes',
    create_new_story: 'Crear nueva historia',
    tone: 'Tono',
    style: 'Estilo',
    genre: 'Género',
    loading_your_stories: 'Cargando tus historias...',
    edit_story: 'Editar historia',
    story_preferences: 'Preferencias de la historia',
    please_input_your: 'Por favor, introduce tu',
    add_character_names_and_press_enter:
      'Añade nombres de personajes y presiona Enter',
    select_or_type_your: 'Selecciona o escribe tu',
    enter_your: 'Introduce tu',
    position_of_the_story_in_the_lesson:
      'Posición de la historia en la lección. La historia se añadirá como un bloque en la posición especificada.',
    save_previous_content_on_the_pages:
      'Guardar contenido previo en las páginas',
    the_existing_content_in_the_selected_pages:
      'El contenido existente en las páginas seleccionadas será reemplazado por la historia generada.',
    real_world_scenario: 'Escenario del mundo real',
    add_optional_instructions:
      'Añadir instrucciones opcionales (tono, longitud, audiencia, etc.)',
    ready_to_enerate_your_real_world_scenario:
      'Listo para generar tu escenario del mundo real',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Haz clic en "Generar escenario del mundo real" para crear un escenario realista basado en el contenido de tu lección.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'La IA analizará el tema y contenido de tu lección',
    generate_a_practical_real_world_scenario:
      'Generar un escenario práctico del mundo real',
    you_can_then_edit_and_customize_the_result:
      'Luego podrás editar y personalizar el resultado',

    add_it_as_a_new_page_to_your_lesson:
      'Añadir como nueva página a tu lección',
    regenerate_with_instructions: 'Regenerar con instrucciones',
    add_real_world_scenario: 'Añadir escenario del mundo real',
    generate_real_world_scenario: 'Generar escenario del mundo real',
    simulation_has_been_stopped: '¡La simulación se ha detenido!',
    loading_simulation: 'Cargando simulación...',
    you_have_exhausted_all_the_attempts: 'Has agotado todos los intentos',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Estudia el escenario en esta página y selecciona la respuesta correcta de las opciones siguientes.',
    attempts_limit_reached:
      'Se ha alcanzado el límite de intentos. Puedes jugar de nuevo pero tu puntuación no se guardará.',
    play_again: 'Jugar de nuevo',
    import_music_from_computer: 'Importar música desde el ordenador.',
    more: 'más',
    no_badge_yet: 'Aún no hay insignias',
    competition_filter: 'Filtro de competición',
    global_leaderboard: 'Clasificación global',
    placeholder_for_the_global_leaderboard:
      'Este es un marcador de posición para la Clasificación Global.',
    badge_editor: 'Editor de insignias',
    adjust_the_appearance_of_this_badge_icon:
      'Ajusta la apariencia de este icono de insignia. Los cambios se aplican solo a esta insignia.',
    badge_style: 'Estilo de insignia',
    the_image_must_be_pixels: 'La imagen debe tener 200x200 píxeles.',
    badge_name: 'Nombre de la insignia',
    badge_descrription: 'Descripción de la insignia',
    enter_badge_criteria: 'Introduce criterios de insignia',
    discard: 'Descartar',
    badge_enable: 'Insignias activadas',
    award_users_with_badges_to_highlight_the_milestones:
      'Otorga insignias a los usuarios para resaltar los hitos en su aprendizaje.',
    badge_types: 'Tipos de insignias',
    enable_or_disable_specific_badge_types_for_your_users:
      'Habilita o deshabilita tipos específicos de insignias para tus usuarios.',
    levels_enabled: 'Niveles activados',
    level_rules: 'Reglas del nivel',
    points: 'Puntos',
    add_new_level: 'Añadir nuevo nivel',
    add_level: 'Añadir nivel',
    points_enabled: 'Puntos activados',
    learning_activities_and_encourage_healthy_competition:
      'Otorga puntos a los usuarios por diferentes actividades de aprendizaje y fomenta la competencia saludable.',
    award_points: 'Otorgar puntos',
    the_following_equates_the_value_of_one_item_completion:
      'Lo siguiente equivale al valor de completar un ítem',
    general: 'General',
    others: 'Otros',
    certificate: 'Certificado',
    quiz_passed: 'Cuestionario aprobado',
    tip_approved: 'Consejo aprobado',
    tip_liked: 'Consejo gustado',
    rewards: 'Recompensas',
    offer_discounts_when_learners_achieve:
      'Ofrece descuentos cuando los alumnos alcanzan un conjunto de puntos, insignias o niveles.',
    give_rewards: 'Dar recompensas',
    discount_course_purchases_by: 'Descuento en la compra de cursos de',
    with_points_more_than: 'con puntos superiores a',
    with_badges_more_than: 'con insignias superiores a',
    with_level_upwards_more_than: 'con nivel superior a',
    leaderboard: 'Clasificación',
    leaderboard_enabled: 'Clasificación activada',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Las clasificaciones ofrecen a los usuarios una visión general de su progreso en puntos en comparación con los demás.',
    show_levels: 'Mostrar niveles',
    show_points: 'Mostrar puntos',
    show_badges: 'Mostrar insignias',
    show_courses: 'Mostrar cursos',
    show_certificates: 'Mostrar certificados',
    leaderboard_settings: 'Configuración de la clasificación',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Configura experiencias de clasificación atractivas para aumentar la motivación del alumno.',
    award_users_with_points_for_different_learning_activities:
      'Otorga puntos a los usuarios por diferentes actividades de aprendizaje.',
    badge_set: 'Conjunto de insignias',
    choose_the_type_of_badges_your_users:
      'Elige el tipo de insignias que tus usuarios ganarán mientras aprenden.',
    levels: 'Niveles',
    Levels_represent_the_stages:
      'Los niveles representan las etapas en el recorrido de aprendizaje de un usuario.',
    enabled: 'Activado',
    disabled: 'Desactivado',
    quick_select: 'Selección rápida',
    yesterday: 'Ayer',
    last_week: 'La semana pasada',
    Last_month: 'El mes pasado',
    last_quarter: 'El trimestre pasado',
    historical_leaderboard: 'Clasificación histórica',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Sigue tu rendimiento y ve cómo te posicionas entre tus compañeros',
    time_period: 'Periodo de tiempo',
    page_of: 'Página 1 de 1',
    edit_competition: 'Editar competición',
    create_competition: 'Crear competición',
    arrow_right: 'flecha-derecha',
    update_competition: 'Actualizar competición',
    competition_title: 'Título de la competición',
    enter_competition_title: 'Introduce el título de la competición',
    enter_competition_description: 'Introduce la descripción de la competición',
    leaderboard_skill: 'Habilidad',
    select_a_skill: 'Selecciona una habilidad',
    no_skills_found: 'No se encontraron habilidades',
    competition_period: 'Periodo de la competición',
    add_badge_rule: 'Añadir regla de insignia',
    create_badge: 'Crear insignia',
    add_level_rule: 'Añadir regla de nivel',
    selected_participants: 'Participantes seleccionados',
    no_participants: 'Sin participantes',
    start_end_date: 'Fecha de inicio–fin',
    created_date: 'Creado por',
    new_competition: 'Nueva competición',
    competitions_list: 'Lista de competiciones',
    search_competitions: 'Buscar competiciones...',
    are_you_sure_you_want_to_delete_the_competition:
      '¿Estás seguro de que quieres eliminar la competición?',
    history: 'Historial',
    export: 'Exportar',
    search_by_name: 'Buscar por nombre...',
    no_historical_data_available_for_the_selected_period:
      'No hay datos históricos disponibles para el periodo seleccionado.',
    no_leaderboard_data_available: 'No hay datos de clasificación disponibles.',
    competitions: 'Competiciones',
    leaderboards: 'Clasificaciones',
    welcome_back: 'Bienvenido de nuevo',
    track_your_performance_and_see: 'Sigue tu rendimiento y ve tu posición',
    team_leaderboard: 'Clasificación del equipo',
    try_again: 'Intentar de nuevo',
    no_competitions_for_search: 'No hay competiciones disponibles para',
    no_competitions_available: 'No hay competiciones disponibles',
    no_competitions_matching_search:
      'No se encontraron competiciones que coincidan con tu búsqueda. Intenta ajustar tus términos o vuelve más tarde.',
    no_competitions_general:
      'Actualmente no hay competiciones configuradas. Vuelve más tarde o contacta con tu administrador para crear nuevas competiciones.',
    media_management: 'Gestión de medios',
    badgess_set: 'Conjunto de insignias',
    choose_the_default_visual_style_for_badge:
      'Elige el estilo visual predeterminado para los iconos de insignias utilizados en la plataforma.',
    enable_badges: 'Activar insignias',
    add_badge: 'Añadir insignia',
    min: 'Mín',
    max: 'Máx',
    your_rank: 'Tu rango',
    your_points: 'Tus puntos',
    your_level: 'Tu nivel',
    rank: 'Rango #',
    level: 'Nivel',
    progress: 'Progreso',
    new_folder: 'Nueva carpeta',
    file_upload: 'Subir archivo',
    writer: 'Autor',
    text_documents: 'Documentos de texto',
    spreadsheets: 'Hojas de cálculo',
    impress: 'Presentación',
    presentations: 'Presentaciones',
    capture_desktop_screen: 'Capturar pantalla del escritorio',
    capture_desktop_screens: 'Capturar pantallas del escritorio',
    your_documents: 'Tus documentos',
    manage_your_videos_images_audio_files:
      'Gestiona tus vídeos, imágenes, archivos de audio y otros recursos utilizados en la creación de contenido.',
    your_organization_documents: 'Documentos de tu organización',
    keep_your_organization_creative_assets_organized:
      'Mantén los recursos creativos de tu organización organizados y accesibles—optimiza el trabajo en equipo y la producción de contenido.',
    your_public_documents: 'Tus documentos públicos',
    curated_collection_of_media_assets_available:
      'Una colección curada de recursos multimedia disponible para todos—explora, reutiliza y crea.',
    your_download_center_documents: 'Documentos de tu centro de descargas',
    repository_of_approved_media_assets_for_download:
      'Repositorio de recursos multimedia aprobados para descargar y usar en tus proyectos.',
    search_files_and_folders: 'Buscar archivos y carpetas..',
    home: 'Inicio',
    folders: 'Carpetas',
    folder_name: 'Nombre de la carpeta',
    owner: 'Propietario',
    last_updated: 'Última actualización',
    action: 'Acción',
    no_folders_found: 'No se encontraron carpetas',
    files: 'Archivos',
    enabling_ai: 'Activando IA...',
    rename: 'Renombrar',
    copy: 'Copiar',
    move: 'Mover',
    verson_history: 'Historial de versiones',
    manage_permission: 'Gestionar permisos',
    generate_audit_report: 'Generar informe de auditoría',
    last_edited: 'Última edición',
    no_files_found: 'No se encontraron archivos',
    are_you_sure_you_want_to_make_this_item_public:
      '¿Estás seguro de que deseas hacer público este elemento? Se copiará en tu biblioteca pública.',
    move_to_organization: 'Mover a la organización',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      '¿Estás seguro de que deseas copiar este elemento a la biblioteca de tu organización?',
    are_you_sure_you_want_to_make_this_item_private:
      '¿Estás seguro de que deseas hacer privado este elemento? Se copiará en tu biblioteca personal.',
    date_modified: 'Fecha de modificación',
    workflow_management: 'Gestión del flujo de trabajo',
    configure_editors_approvers_and_viewers_for_this_document:
      'Configura editores, aprobadores y espectadores para este documento.',
    error_Loading_editor: 'Error al cargar el editor',
    debug_info: 'Información de depuración',
    loading_editor: 'Cargando editor...',
    submitted_for_review: 'Enviado para revisión',
    editors: 'Editores',
    no_editors_added_yet:
      'Aún no se han añadido editores. Haz clic en "Añadir editor" para agregar uno.',
    add_editor: 'Añadir editor',
    approvers: 'Aprobadores',
    no_approvers_added_yet:
      'Aún no se han añadido aprobadores. Haz clic en "Añadir aprobador" para agregar uno.',
    add_approvers: 'Añadir aprobador',
    viewer: 'Espectador',
    no_viewers_added_yet:
      'Aún no se han añadido espectadores. Haz clic en "Añadir espectador" para agregar uno.',
    add_viewer: 'Añadir espectador',
    are_you_sure_you_want_to_delete_the_selected_items:
      '¿Estás seguro de que deseas eliminar los elementos seleccionados?'
  },
  v3: {
    reportShareSphere: 'Esfera Compartida',
    overview: 'Resumen de la categoría',
    triviaReport: 'Categoría ShareSphere',
    overviewGraph: 'Gráfico resumen de la categoría',
    category: 'Categoría',
    phCategory: 'Selecciona una categoría',
    podcast: 'Podcast, música e historias',
    pastPodcast: 'Podcasts pasados',
    upcomingPodcast: 'Próximos podcasts',
    podcastLanguageTitle: 'Idioma del podcast, música e historias',
    podcastLanguageCheckbox: 'Usar IA para el idioma de mi podcast',
    howRate: '¿Cómo calificas este podcast?',
    podcastSubmit: 'Enviar',
    podcastGuest: 'Invitado:',
    podcastReview: 'Reseñas',
    podcastEpishode: 'Episodio',
    podcastEnd: 'Podcast finalizado',
    date_podcast: 'Fecha del podcast',
    skill_not_found: '¡Lo sentimos! No se encontró la ruta de habilidades.',
    coaching: 'Entrenamiento',
    webinar: 'Webinar',
    public_conference: 'Conferencia pública',
    skill_journey_subtitle:
      'Configura tu ruta de habilidades y elige quién puede verla e interactuar con ella.',
    enable_white_label: 'Habilitar White Label',
    create_new_event_org: 'Crear un nuevo evento para tu organización',
    create_new_event_marketplace: 'Crear un nuevo evento para el marketplace',
    create_new_event_both:
      'Crear un nuevo evento para tu organización y el marketplace',
    event_outline: 'Introduce el esquema del evento',
    event_obj: 'Introduce los objetivos del evento',
    event_description: 'Introduce la descripción del evento',
    create_new_metamaze_org: 'Crear un nuevo MetaMaze para tu organización',
    create_new_metamaze_marketplace:
      'Crear un nuevo MetaMaze para el marketplace',
    create_new_metamaze_both:
      'Crear un nuevo MetaMaze para tu organización y el marketplace',
    add_key_words: 'Añadir palabras clave',
    press_enter_make_keyword: 'Pulsa Enter para crear una palabra clave',
    disable_skip_quiz: 'Deshabilitar saltar el cuestionario',
    warning_complete_quiz:
      'Por favor, completa el cuestionario para continuar.',
    signup_email_verification:
      'Hemos enviado un enlace de confirmación a tu correo electrónico. Por favor, haz clic en el enlace para confirmar el registro.',
    verifying_registration: 'Verificando el registro...',
    reset_password_linK:
      'Hemos enviado un enlace para restablecer la contraseña a tu correo electrónico. Por favor, haz clic en el enlace para crear una nueva contraseña.',
    reset_email_error:
      'Usuario con ese correo no encontrado, ¡prueba con el nombre de usuario!',
    first_name: 'Nombre',
    last_name: 'Apellido',
    error_firstName: 'Por favor, introduce el nombre',
    error_sharebot_organization: 'Por favor, introduce la organización',
    error_lastName: 'Por favor, introduce el apellido',
    private_conference: 'Conferencia privada',
    public_conference: 'Conferencia pública',
    discussion_room: 'Sala de discusión',
    training_no_courses: 'Actualmente no estás inscrito en ningún curso.',
    training_no_events: 'Actualmente no estás participando en ningún evento.',
    allow_sharing_trainer_info:
      'Permitir que el marketplace comparta el correo electrónico',
    error_username_space: 'El nombre de usuario no puede contener espacios.',
    error_sharebot_organization_space:
      'El nombre de la organización no puede contener espacios.',
    edit_permission: 'Permiso para editar',
    valid_price: 'El precio debe ser mayor que 0',
    course_price_message: `*Los cursos solo están disponibles para usuarios que los compraron a través de la organización y no se pueden revender en el marketplace`,
    valid_edit_price:
      'El precio de edición debe ser menor que el precio de compra.',
    my_calendar: 'Mi calendario',
    error_valid_firstName: 'Por favor, introduce un nombre válido.',
    error_valid_organization:
      'Por favor, introduce un nombre de organización válido.',
    error_valid_lastName: 'Por favor, introduce un apellido válido.',
    error_name_spaces: 'El nombre no debe contener espacios',
    items: 'Elementos',
    publish_to_channel: 'Publicar en mi colección de canales',
    create_a_channel: 'Crear mi canal',
    create_a_trivia: 'Crear un cuestionario',
    create_a_new_channel: 'Crear un nuevo canal',
    add_videos: 'Añadir videos',
    save_and_continue: 'Guardar y continuar',
    channel: 'Canal',
    channels: 'Canales',
    view_channel: 'Ver canal',
    edit_channel: 'Editar canal',
    delete_channel: 'Eliminar canal',
    my_video_channels: 'Mis canales de vídeo',
    training_no_channel: 'Actualmente no estás participando en ningún canal.',
    monthly_price_required: 'Se requiere precio mensual',
    yearly_price_required: 'Se requiere precio anual',
    one_time_price_required: 'Se requiere precio único',
    marketplace_quantity: 'Dólares',
    report_webinar: 'Webinar',
    report_coaching: 'Entrenamiento',
    report_channel: 'Canal',
    report_public_conference: 'Conferencia pública',
    report_maze: 'Laberinto',
    channel: 'Canal',
    edit_price: 'Editar precio ($)',
    quantity: 'Cantidad',
    payment_type: 'Tipo de pago',
    total_amount: 'Importe total ($)',
    net_amount: 'Importe neto ($)',
    edit_option: 'Editar opción',
    marketplace_price: 'Precio ($)',
    market_name: 'Nombre',
    duration_min: 'Duración (minutos)',
    users_total: 'Usuarios (total)',
    sales_total: 'Ventas totales (dólares)',
    search_coaching: 'Buscar entrenamiento',
    search_channel: 'Buscar canal',
    search_webinar: 'Buscar webinar',
    search_maze: 'Buscar laberinto',
    search_public_conference: 'Buscar conferencia pública',
    buyer_type: 'Tipo de comprador',
    quanity: 'Cantidad',
    channel_unit_amount: 'Importe neto ($)',
    channel_updated_at: 'Actualizado',
    month_price: 'Precio (mensual)',
    year_price: 'Precio (anual)',
    one_time_price: 'Precio (único)',
    sharebot_organization: 'Añadir nuevo nombre de organización',
    share_sphere: 'Esfera compartida',
    ai_course_title: 'Título del curso',
    ai_input_course_title: '¡Por favor, introduce el título del curso!',
    learning_objective_label: 'Objetivo de aprendizaje',
    learning_objective_message:
      '¡Por favor, introduce el objetivo de aprendizaje!',
    standard_question: '¿Hay algún estándar que el alumno deba seguir?',
    standard_details_label: 'Detalles del estándar',
    standard_details_message:
      '¡Por favor, introduce los detalles del estándar!',
    estimated_duration_label: 'Duración estimada del curso (en minutos)',
    estimated_duration_message: '¡Por favor, introduce la duración estimada!',
    min_duration_message: 'La duración mínima es de 5 minutos.',
    ai_mins: '25 min',
    industry_specific_question: '¿Es específico de un sector?',
    industry_label: 'Especifica el sector',
    industry_message: '¡Por favor, introduce el sector!',
    ai_course_creation: 'Creación de curso con IA',
    course_generated: 'Curso generado por Sharelook',
    ai: 'IA',
    ai_you: 'Tú',
    ai_prompt_ready:
      'Tu prompt está listo. Ahora puedes generar la tabla de contenidos.',
    ai_unable_respond:
      '¡Lo sentimos! La IA no puede responder a tu solicitud. Por favor, inténtalo de nuevo.',
    ai_hide_toc: 'Ocultar tabla de contenidos',
    ai_preview_toc: 'Previsualizar tabla de contenidos',
    ai_generate_toc_now: 'Generar tabla de contenidos ahora',
    ai_creation_course_title: 'Título del curso:',
    ai_creation_industry_specific: '¿Es específico de un sector?:',
    ai_creation_industry: 'Sector:',
    ai_creation_standard_needed:
      '¿Hay algún estándar que el alumno deba seguir?:',
    ai_creation_standard_details: 'Detalles del estándar:',
    ai_creation_estimated_duration: 'Duración estimada del curso (en minutos):',
    minutes: 'minutos',
    ai_creation_learning_objective: 'Objetivo de aprendizaje:',
    setup_again: 'Configurar de nuevo',
    ai_creation_confirm_title:
      '¿Estás seguro de que quieres reiniciar el formulario?',
    ai_creation_confirm_content:
      'El chat y todo el contenido generado se reiniciarán.',
    ai_toc: 'Tabla de contenidos',
    ai_note_topic:
      'Nota: Puedes arrastrar y soltar para reordenar los temas dentro de la lección.',
    ai_add_topic: '+ Añadir tema',
    add_topic: 'Añadir tema',
    add_lesson: 'Añadir lección',
    add_new_lesson: 'Añadir nueva lección',
    ai_add_lesson: '+ Añadir lección',
    attention: 'Atención',
    before_varifying: 'Antes de verificar',
    ai_save_later: 'Guardar para más tarde',
    ai_download_word_doc: 'Descargar como documento Word',
    ai_download_course_word_doc: 'Descargar curso como documento Word',
    ai_create_course_button: 'Crear curso',
    ai_generate_course_content: 'Generar contenido del curso',
    ai_out_of: 'de',
    ai_subtopic_failed_content:
      'subtemas no se han podido generar. Haz clic en "Generar contenido del curso" nuevamente para generar solo esos subtemas.',
    ai_edit_topic: 'Editar tema',
    ai_edit_lesson_title: 'Editar título de lección',
    ai_save_topic: 'Guardar tema',
    ai_save: 'Guardar',
    ai_save_lesson_title: 'Guardar título de lección',
    ai_add_new_topic: 'Añadir nuevo tema',
    ai_download_ref: 'Descargar con referencias',
    ai_download_ref_content:
      'Descargará el curso como documento Word con referencias.',
    ai_download_without_ref: 'Descargar sin referencias',
    ai_download_two_word: 'Se descargarán dos documentos Word:',
    ai_download_two_word_content_one:
      '- uno con el contenido principal sin referencias,',
    ai_download_two_word_content_two:
      'y otro que solo contiene una lista de referencias sin contenido.',
    ai_manage_content: 'Gestionar contenido',
    ai_add_content_from_internet: '+Añadir contenido de Internet',
    ai_confirm_start: 'Confirmar inicio',
    ai_Verify: 'Verificar',
    ai_undo_warning:
      'Este proceso puede llevar algún tiempo. Por favor, no cierres esta ventana hasta que se complete la generación, ya que no se puede deshacer.',
    ai_verified_content:
      'Has verificado el contenido. Ten en cuenta que después de la confirmación, no podrás volver al chat con el asistente de IA con el contenido actual.',
    ai_want_proceed: '¿Estás seguro de que quieres continuar?',
    upload_simulation: 'Subir simulación',
    name_simulation: 'Nombre de la simulación',
    selected_simulation_files: 'Archivos de simulación seleccionados',
    score_between_one_hundred: 'Tu puntuación debe estar entre 1 y 100.',
    are_sure_simulation:
      '¿Estás seguro de eliminar este archivo de simulación?',
    required_simulation: 'Se requiere puntuación',
    required_section_file: 'Se requiere archivo de sección',
    simulation: 'Simulación',
    simulation_quiz_games: 'Necesitas añadir quiz en juegos',
    simulation_alert_des:
      'Solo puedes añadir juegos si todas las preguntas tienen tipo de respuesta única o múltiple.',
    alert_info: 'información',
    ai_number_quiz: 'Número de quiz',
    ai_point: 'Punto',
    ai_points: 'Puntos',
    val_required: 'Requerido',
    games: 'Juegos',
    add_simulation: 'Añadir simulación',
    text_tiewer: 'Visor de texto',
    back_to_account: 'Volver a la cuenta',
    delete_account: 'Eliminar cuenta',
    delete_account_title: '¿Eliminar cuenta?',
    delete_account_subtitle: 'Puedes eliminar tu cuenta desde aquí.',
    delete_account_cannot_undo:
      'Estás a punto de eliminar tu cuenta. Esta acción no se puede deshacer.',
    account_org_profile:
      'También perderás todos los cursos que has creado, tu perfil de organización y todas tus configuraciones.',
    deleting_account_database:
      'Eliminar tu cuenta borrará todos tus datos de nuestra base de datos.',
    account_confirm_delete: '¿Estás seguro de que quieres eliminar tu cuenta?',
    action_cannot_be_undone: 'Esta acción no se puede deshacer.',
    account_delete_message_success:
      'Tu cuenta ha sido eliminada correctamente.',
    message_edit: 'Editar',
    message_delete: 'Eliminar',
    message_reply: 'Responder',
    attached_file: 'Archivo adjunto',
    attach_file: 'Adjuntar archivo',
    attach_des: '25 MB, tamaño máximo de archivo',
    view: 'Ver',
    go_to_marketplace: 'Ir al Marketplace',
    learning_center: 'Centro de aprendizaje',
    knowledge_center: 'Centro de conocimiento',
    sharebot: 'ShareBot',
    sharebot_help_message: '¿Cómo puedo ayudarte hoy?',
    my_organization: 'Mi organización',
    world_knowledge: 'Conocimiento mundial',
    welcome_to_sharelook: '¡Bienvenido a Sharelook!',
    sharelook_you_want_go: '¿A dónde quieres ir hoy?',
    shareLook_learning_management_system:
      'Accede al sistema de gestión de aprendizaje ShareLook para crear o acceder a recursos educativos como eventos en vivo y cursos en tu organización en ShareLook.',
    shareLook_powerful_ai_system:
      'Accede al potente sistema de ShareLook con IA donde puedes subir documentos PDF y obtener información útil en segundos. Obtén respuestas rápidas basadas en los recursos de tu organización o respuestas de nuestro sistema genérico de IA en la sección de conocimiento mundial.',
    edit_now: 'Editar ahora',
    sharelook_log_out:
      'Has cerrado sesión en Sharelook. ¡Por favor, inicia sesión!',
    sorry_error: '¡Lo sentimos! Hemos experimentado un error.',
    login: 'Iniciar sesión',
    refresh_page: 'Actualizar página',
    just_a_moment: 'Un momento',
    enter_lname_fname:
      'Por favor, introduce tu nombre y apellido para continuar.',
    procced_to_sharelook: 'Continuar a Sharelook',
    option_one: 'Opción 1',
    option_two: 'Opción 2',
    selected_image: 'Imagen seleccionada:',
    add_text: 'Añadir texto',
    linkdin_is_required: 'LinkedIn es obligatorio.',
    bio_is_required: 'La biografía es obligatoria.',
    save_user_information: 'Guardar información del usuario',
    select_all: 'Seleccionar todo',
    enable_ai: 'Activar IA',
    load_more: 'Cargar más',
    channel_id: 'ID del canal.',
    send: 'Enviar',
    v4: 'Información',
    subscription: 'Suscripción',
    reset_user_flag: 'REINICIAR BANDERA DE USUARIO',
    delete_my_accont: 'Eliminar mi cuenta',
    sharebot_sub_error: '¡Error al obtener suscripciones. Inténtalo de nuevo!',
    sharebot_no_sub: 'Actualmente no tienes suscripciones activas.',
    sharebot_dont_sub: 'No tienes suscripciones anteriores.',
    sharebot_prev_sub: 'Anteriormente suscrito',
    sharebot_sub: 'Suscripción a ShareBot',
    sharebot_un_sub: 'Cancelar suscripción a ShareBot',
    sharebot_no_available: 'No hay descripción disponible',
    sharebot_start_date: 'Fecha de inicio:',
    sharebot_end_date: 'Fecha de fin:',
    sharebot_sure: '¿Estás seguro?',
    sharebot_do_you_want: '¿Quieres',
    unsubscribe: 'cancelar la suscripción',
    unsubscribe_what: 'cancelar la suscripción?',
    subscribe: 'suscribirte',
    subscribe_what: 'suscribirte?',
    subscribe_now: 'Suscribirse ahora',
    confirm: 'Confirmar',
    sharebot_intel_knowledge_center:
      'Centro de conocimiento inteligente de ShareBot',
    sharebot_welcome_paragraph:
      'Bienvenido al Centro de conocimiento de ShareBot, el chatbot avanzado con IA diseñado para transformar cómo los profesionales acceden a la información y colaboran.',
    expired: 'Caducado',
    active: 'Activo',
    Inactive: 'Inactivo',
    yearly_subscription: 'Suscripción anual',
    monthly_subscription: 'Suscripción Mensual',
    no_sharebot_org: 'No tienes ninguna organización de ShareBot',
    sharebot_start_free_trial: 'Comenzar prueba gratuita',
    sub_month: 'Suscripción Mensual',
    sub_year: 'Suscripción Anual',
    question_per_month: 'Almacenamiento de datos (1TB) y 1000 preguntas al mes',
    sharebot_para:
      'Al continuar, estás confirmando la eliminación inmediata de la organización. Esta acción resultará en la pérdida de todos los valiosos conocimientos proporcionados por ShareBot, y no se puede deshacer.',
    cancelled_date: 'Fecha de Cancelación:',
    live_straming_para:
      'Si deseas cambiar tu límite mensual de transmisión en vivo, por favor contacta a',
    sharelook_agree: 'Estoy de acuerdo con los',
    terms_condition: 'términos y condiciones',
    and: 'y',
    privacy_policy: 'política de privacidad de Sharelook',
    save_for_later: 'Guardar para más tarde',
    ai: 'IA',
    no_video_yet: '¡No se ha seleccionado ningún vídeo todavía!',
    are_you_sure_delete_video: '¿Estás seguro de eliminar este vídeo?',
    video_des: 'Descripción',
    video_now: 'Ahora',
    video_playing: 'Reproduciendo:',
    video_no: 'Vídeo Nº',
    ai_generated_course: 'Curso Generado por IA',
    create_course_on_our_own: 'Crear un curso por tu cuenta',
    ai_Assisted_ourse_reation: 'Creación de Curso Asistido por IA',
    pending: 'Pendiente',
    published: 'Publicado',
    intro_course: '¿en tu curso?',
    clone_course: '¿Te gustaría clonar',
    browser_audio_not_support: 'Tu navegador no admite la etiqueta de audio.',
    audio_popup_content:
      'Donde puedes utilizar muchos estilos de voz sobre el texto que escribes. Bla Bla bla. Lorem Ipsum es simplemente un texto ficticio de la industria de la impresión y la tipografía. Lorem Ipsum ha sido el texto ficticio estándar de la industria desde el siglo XVI.',
    close: 'Cerrar',
    podcast_rec: 'GRABAR',
    create_podcast: 'Crear Podcast',
    add_admin: 'AÑADIR ADMINISTRADOR',
    delete_all: 'Eliminar todo',
    ai_podcast_audio: 'Audio de Podcast IA',
    language: 'Idioma',
    podcast_download_content:
      '*Descarga el archivo de audio IA para editarlo y convertirlo en tu archivo de audio.',
    upload_audio: 'Subir Audio',
    browser_do_not_support_audio:
      'Tu navegador no admite el elemento de audio.',
    upload_cover: 'Subir Portada',
    upload_ai_creator: 'Creador IA',
    required_cover_image: '¡La imagen de portada es obligatoria!',
    room_required_name: '¡El nombre del podcast es obligatorio!',
    add_guest_list: '¡Por favor añade la lista de invitados!',
    podcast_add_participants: 'AÑADIR PARTICIPANTE',
    topic_required: 'Se requiere al menos un tema',
    podcast_description: 'DESCRIPCIÓN',
    podcast_date: 'FECHA',
    date: 'Fecha',
    podcast_time: 'hora',
    podcast_to: 'hasta',
    podcast_all_day: 'Todo el día',
    podcast_start_date_time: '¡Se requiere la fecha y hora de inicio!',
    podcast_id: 'ID',
    selected_user: 'Invitar a los usuarios seleccionados',
    see_more: 'Ver más',
    see_less: 'Ver menos',
    no_review_yet: 'Sin reseñas aún, sé el primero en opinar.',
    request_to_speak: '¿Aceptar la solicitud del usuario para hablar?',
    kick_user: '¿Quieres expulsar a este usuario?',
    accept_request: 'Aceptar Solicitud',
    kick: 'EXPULSAR',
    started: 'INICIADO',
    end: 'FINALIZAR',
    join_now: 'Unirse ahora',
    podcast_end: 'El podcast ha finalizado',
    connecting: 'conectando...',
    knowledge_center_know_today: '¿Qué te gustaría saber hoy?',
    knowledge_center_question: 'Por favor, introduce una pregunta primero',
    knowledge_center_error: '¡Lo sentimos! Hemos experimentado un error.',
    knowledge_center_tooltrip:
      'Obtén respuestas rápidas a partir de los recursos de aprendizaje del repositorio de tu organización en ShareLook, con referencias adecuadas y la posibilidad de previsualizar y descargar los documentos PDF referenciados.',
    my_organization: 'Mi Organización',
    world_knowledge: 'Conocimiento Mundial',
    open_file: 'Abrir Archivo',
    reference: 'Referencia',
    are_you_cancel: '¿Estás seguro de que deseas cancelar?',
    are_you_remove_media: '¿Estás seguro de que deseas eliminar el medio?',
    terms_agree: 'Estoy de acuerdo con estos',
    ready: 'Listo',
    send_email: 'ENVIAR CORREO',
    active_users: 'Usuarios activos',
    sign_up_user: 'Usuarios registrados',
    non_sign_up_user: 'Usuarios no registrados',
    organisation: 'Organización',
    usage_report: 'Informe de Uso',
    check_email: 'revisa tu correo electrónico',
    delete_schedule: 'Eliminar Horario',
    are_you_sure_delete_schedule: '¿Estás seguro de eliminar este horario?',
    add_task: '¡Por favor, introduce una tarea!',
    coaching_available: 'Marcar como disponibilidad para coaching',
    message_booking_coaching:
      'Este horario ha sido reservado por un usuario para coaching.',
    task_day: 'Día de Tarea',
    created_task_day: 'Has creado una tarea para este día.',
    event_day: 'Día de Evento',
    has_booked_coaching:
      'Se ha reservado una sesión de coaching para este día.',
    active_day: 'Día Activo',
    selectable_time_slots:
      'Las franjas horarias seleccionables a la derecha están activas para este día.',
    compare_last_month: 'En comparación con el mes pasado',
    uploading_file: 'Subiendo tu archivo',
    attach_file_course: 'adjunto a este curso.',
    fetch_request: 'Obteniendo tu solicitud',
    finilize_upload: 'Finalizando subida',
    scorm_scanned:
      'Por favor espera... Tu archivo SCORM está siendo escaneado.',
    scan_status: 'Estado del escaneo:',
    scan_completed: 'Escaneo completado. Tu archivo está',
    scan_progress: 'Escaneo en progreso...',
    check_scorm:
      'Comprobando el formato del archivo SCORM... Por favor espera...',
    file_check_success: 'Verificación del archivo exitosa',
    file_check_progress: 'Verificación del archivo en progreso...',
    scorm_not_upload:
      'Tu archivo no cumple con el estándar SCORM 1.2. Por favor, vuelve a subir un archivo compatible.',
    select_question:
      'Opciones de respuesta (selecciona una respuesta correcta)',
    select_answer: '¡Por favor selecciona una opción de respuesta!',
    check_option_one: '¡Por favor, introduce la opción uno!',
    check_option_two: '¡Por favor, introduce la opción dos!',
    check_option_three: '¡Por favor, introduce la opción tres!',
    check_option_four: '¡Por favor, introduce la opción cuatro!',
    question_image: 'Imagen de la Pregunta',
    select_question_image: '¡Por favor selecciona una imagen de pregunta!',
    ans_image: 'Imagen de Respuesta',
    upload_image_question: 'Subir Imagen de Respuesta',
    select_image_answer: '¡Por favor selecciona una imagen de respuesta!',
    save_question: 'Guardar Pregunta',
    do_you_leave: '¿Estás seguro de que deseas salir?',
    loose_all_progress: 'Perderás todo tu progreso.',
    welcome: 'Bienvenido',
    team_knowledge_quest: 'Búsqueda de Conocimiento en Equipo',
    your_score: 'Tu Puntuación',
    start_playing: 'Comenzar a jugar',
    share_sphere_complete: 'ShareSphere Completado',
    final_score: 'Puntuación Final',
    play_next: 'Jugar Siguiente',
    you_donot_access_event: 'No tienes acceso a este evento.',
    ai_content_generated: 'El contenido ha sido generado para este tema.',
    ai_popup_confirm_content: 'Confirmar Generación de Contenido',
    limit_transcribe_text:
      'Minutos restantes de transcripción: <0>{{ transcribe_limit }}</0> minutos <1/><2/> <3>. Para cambiar tu límite de transcripción, por favor contacta con </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'No tienes acceso a este evento.',
    ai_course_title_training: 'Cursos de formación en liderazgo',
    ai_course_object: 'Navegando el liderazgo en la era digital',
    create_ai_video: 'Crear vídeo con IA',
    generate: 'GENERAR',
    video_generate_process:
      'El proceso de generación del vídeo puede tardar un poco. Recibirás un correo electrónico una vez finalizado.',
    stripe_account_connect:
      'Tu cuenta de Stripe está inactiva. Por favor, conéctala o actívala para continuar.',
    ai_creator: 'Creador con IA',
    check_video_status: 'Comprobando el estado de la generación del vídeo...',
    video_on_queue: 'El vídeo está en cola para ser generado.',
    video_fail_generation:
      'Lo sentimos, la generación del vídeo ha fallado. Intenta con otro.',
    video_currently_generated: 'Este vídeo se está generando actualmente.',
    checking_status: 'Comprobando estado',
    check_status: 'Comprobar estado',
    browser_does_not_support_audio:
      'Tu navegador no admite la etiqueta de audio',
    existing_edit_scenario:
      '¿Quieres editar el escenario existente o crear uno nuevo? Si creas uno nuevo, se perderá el anterior.',
    generate_scenario: 'Generar escenario',
    layout: 'Diseño',
    confirm_change: 'Confirmar cambio',
    generated_ai_creation_message:
      'Ten en cuenta que solo se conservarán los elementos de texto generados por IA. Todos los demás elementos se eliminarán de la página.',
    generate_story: 'Generar historia',
    save_original_content: 'Guardar contenido original:',
    story_added_specified_position:
      'La posición de la historia en la lección. Se añadirá como un bloque en la posición especificada.',
    position_of_story: 'Posición de la historia',
    start_the_lesson: 'Inicio de la lección',
    end_the_lesson: 'Fin de la lección',
    add_story_pages: 'Añadir historia a las páginas',
    browser_does_not_support: 'Tu navegador no admite el elemento de audio.',
    no_video_available: 'No hay vídeos disponibles.',
    no_podcast_available: 'No hay pódcasts disponibles.',
    no_item_baskets: 'No hay artículos en la cesta.',
    ai_course_object: 'Navegando el liderazgo en la era digital'
  },
  v2: {
    n_data: 'Sin datos',
    change: 'Cambiar',
    remove: 'Eliminar',
    auto_background: 'Fondo automático',
    create_new_course_org: 'Crea un nuevo curso para tu organización.',
    create_new_course_marketplace: 'Crea un nuevo curso para el mercado.',
    create_new_course_both:
      'Crea un nuevo curso para tu organización y el mercado.',
    ok: 'Aceptar',
    page_bg: 'Fondo de página',
    lesson_cover: 'Imagen de portada de la lección',
    create_skill_journey: 'Crear un itinerario de habilidades',
    Metamaze: 'Metamaze',
    events: 'Eventos',
    scroms: 'SCORMs',
    min_score_pass: 'Puntuación mínima para aprobar',
    no_scorms_available: 'No hay SCORMs disponibles.',
    no_events_available: 'No hay eventos disponibles.',
    no_courses_available: 'No hay cursos disponibles.',
    no_courses_baskets: 'No hay cursos en la cesta.',
    no_mazes_baskets: 'No hay laberintos en la cesta.',
    no_scroms_baskets: 'No hay SCORMs en la cesta.',
    no_events_baskets: 'No hay eventos en la cesta.',
    sorry: '¡Lo sentimos!',
    option_1: 'Opción 1',
    option_2: 'Opción 2',
    enter_number_words: 'Introduce el número máximo de palabras.',
    summarize: 'Resumir',
    answer: 'Responder',
    hold_tight_one_minute:
      '¡Espera un momento! Aún estamos preparando. Esto puede tardar hasta un minuto.',
    enter_question: 'Introduce tu pregunta.',
    enter_relevant_documents: 'Introduce el número de documentos relevantes.',
    please_input_relevant_documents:
      '¡Por favor, introduce el número de documentos relevantes!',
    please_wait_loading_results:
      'Por favor, espera a que se carguen los resultados...',
    proceed_to_add_voice: 'Proceder a añadir voz',
    results: 'Resultados',
    no_result_found_try_asking_questions:
      'No se encontraron resultados. Intenta hacer más preguntas.',
    eg: 'p. ej.,',
    what_make_sales_manager: '¿Qué puede hacerme un gerente de ventas?',
    please_select_lang: '¡Por favor, selecciona un idioma!',
    search: 'Buscar',
    please_copy_desired_content:
      'Por favor, copia el contenido deseado de la caja izquierda a la derecha.',
    rating_req: 'La valoración es un campo obligatorio.',
    review_req: 'La reseña es un campo obligatorio.',
    rating_review_req:
      'Debes proporcionar tanto una valoración como una reseña.',
    how_rate_this: '¿Cómo valorarías esto?',
    amazing_above_expectations: '¡Increíble! ¡Por encima de las expectativas!',
    certificates: 'Certificados',
    you_no_certificates: 'No tienes certificados disponibles en este momento.',
    please_add_review:
      'Por favor, proporciona una reseña junto con la valoración. ¡Gracias!',
    post: 'Publicar',
    rate: 'Valorar',
    avg_rating: 'Valoración media',
    no_review_found: 'No se encontraron reseñas',
    are_sure_to_disale_zoom_integration:
      '¿Estás seguro de que quieres desactivar la integración con Zoom?',
    badges: 'Insignias',
    you_no_badge_available: 'No tienes insignias disponibles en este momento.',
    download_certificate: 'Descargar certificado',
    loading: 'Cargando...',
    no_file_attached: 'No hay archivos adjuntos',
    you_do_not_have_any_notes: 'No tienes ninguna nota.',
    question: 'Pregunta',
    score: 'Puntuación',
    alert_score_message: 'Persona(s) han enviado sus puntuaciones.',
    alert_question_message: 'No se han añadido preguntas hasta ahora.',
    button_submit: 'Enviar',
    button_allScores: 'Todas las puntuaciones han sido enviadas.',
    record_wait: 'La grabación está empezando. Por favor, espera...',
    buttonSubmit_warning:
      'Por favor, introduce todas las puntuaciones antes de enviar.',
    upload_ar_assets: 'Subir recursos AR',
    edit_ar_assets: 'Editar recursos AR',
    edit_maze_assets: 'Editar recursos MetaMaze',
    upload_assets: 'Subir recursos',
    upload_maze_assets: 'Subir recursos MetaMaze',
    trigger_title: 'Título del disparador',
    model_title: 'Título del modelo',
    trigger_description: 'Descripción del disparador',
    model_description: 'Descripción del modelo',
    please_type_target_description:
      'Por favor, escribe la descripción del objetivo.',
    please_type_model_description:
      'Por favor, escribe la descripción del modelo.',
    trigger_image: 'Imagen del disparador*',
    model_image: 'Imagen del modelo*',
    upload_trigger_image: 'Subir imagen del disparador',
    upload_model_image: 'Subir imagen del modelo',
    drag_n_drop: 'Arrastrar y soltar',
    file_size_should_not_exceed:
      '(El tamaño del archivo de imagen (JPEG) no debe superar los 512 KB)',
    zip_size_should_not_exceed:
      '(El tamaño del archivo ZIP no debe superar los 60 MB)',
    ar_content: 'Contenido AR*',
    model_content: 'Modelo 3D*',
    upload_3d_zip: 'Subir ZIP / Vídeo',
    upload_3d_maze_zip: 'Subir ZIP',
    audio_content: 'Contenido de audio',
    _mp3: '(.mp3)',
    content_attached: 'Archivo ZIP adjuntado.',
    video_attached: 'Vídeo adjuntado.',
    audio_attached: 'Audio adjuntado.',
    enter_trigger_image_title:
      'Introduce el título de la imagen del disparador.',
    enter_model_title: 'Introduce el título del modelo MetaMaze.',
    ar_preview_image: 'Imagen previa AR',
    upload_preview_image: 'Subir imagen previa',
    upload_audio: 'Subir audio',
    creating___: 'Creando...',
    updating___: 'Actualizando...',
    create: 'Crear',
    update: 'Actualizar',
    ar_assets: 'Imagen 3D',
    _3d_files_mp4: '(Archivos .obj, .fbx comprimidos o vídeo .mp4)',
    _3d_files_mp4_ar: '(Archivos .obj, .fbx comprimidos)',
    maze_3d_files_mp4: '(Archivos .obj, .fbx comprimidos)',
    _jpg_files: 'Solo se admiten archivos .jpg',
    persons_have_submitted_their_scores:
      'Persona(s) han enviado sus puntuaciones.',
    no_questions_added_till_now: 'No se han añadido preguntas aún.',
    submit: 'Enviar',
    all_scores_submitted: 'Todas las puntuaciones han sido enviadas.',
    recording_is_starting: 'La grabación está comenzando. Por favor espera...',
    please_input_scores_before_submitting:
      'Por favor, introduce todas las puntuaciones antes de enviar.',
    end_for_all: 'Finalizar para todos',
    full_screen: 'Pantalla completa',
    breakout_room: 'Sala de reuniones',
    send_invitations: 'Enviar invitación(es)',
    add_participants: 'Añadir participante(s)',
    create_breakout_room: 'Crear sala de reuniones',
    connecting: 'Conectando...',
    currently_broadcaster_unavailable:
      'Actualmente, el emisor no está disponible.',
    how_many_breakout_room_to_create:
      '¿Cuántas salas de reuniones quieres crear?',
    create_upto_three_breakout_rooms: '*Crear hasta 3 salas de reuniones',
    allow: 'Permitir',
    additional: 'Adicional',
    attachment: 'Archivos adjuntos',
    no_description_available: 'No hay descripción disponible.',
    people: 'PERSONAS',
    waiting: 'Esperando',
    hand_raising_users: 'Usuarios levantando la mano',
    invite: 'Invitar',
    create_room: 'Crear sala',
    create_live_event: 'Crear evento en directo',
    support_upto_fivethousand_participants:
      'Soporta hasta 5.000 participantes para el evento',
    support_upto_ten_participants:
      'Soporta hasta 10 participantes con vídeo en directo',
    support_upto_twohundred_participants:
      'Soporta hasta 200 participantes para el evento',
    supprt_upto_five_participants:
      'Soporta hasta 5 participantes con vídeo en directo',
    support_upto_twentyfive_participants:
      'Soporta hasta 25 participantes con vídeo en directo para el evento',
    two_live_video_participants:
      'Hay 2 participantes con vídeo en directo para el evento (anfitrión y asistente)',
    you_can_have_upto_five_examinees: 'Solo puedes tener hasta 5 examinados.',
    you_can_have_upto_twentyfive_participants:
      'Solo puedes tener hasta 25 participantes.',
    you_can_have_upto_five_participants:
      'Solo puedes tener hasta 5 participantes.',
    you_can_have_upto_ten_participants:
      'Solo puedes tener hasta 10 participantes.',
    select_hosts_email: 'Selecciona el correo electrónico del anfitrión',
    send_invite_email: 'Enviar correo de invitación',
    do_not_send_invite_email: 'No enviar correo de invitación',
    error: 'Error',
    max_twentyfive_users_allowed:
      'Máximo 25 usuarios permitidos para seleccionar',
    max_five_users_allowed: 'Máximo 5 usuarios permitidos para seleccionar',
    max_ten_users_allowed: 'Máximo 10 usuarios permitidos para seleccionar',
    no_user_found: 'No se encontraron usuarios',
    transcribe_to: 'Transcribir a',
    integrate_zoom_to_start_meeting:
      'Integra Zoom en tu cuenta para iniciar una reunión de Zoom.',
    zoom_is_not_integrated: 'Zoom no está integrado.',
    delete_poll: 'Eliminar encuesta',
    add_poll: 'Añadir encuesta',
    live_now: '¡EN DIRECTO!',
    average_rating: 'Valoración media',
    review: 'Reseña',
    time_spent: 'Tiempo empleado',
    total: 'Total',
    mins: 'Minutos',
    no_data: 'No hay datos para este cuestionario.',
    total_score: 'Puntuación Total',
    pass_score: 'Puntuación de Aprobación',
    point: 'Punto',
    wrong: 'Incorrecto',
    response: 'Respuesta',
    submitted: 'Enviado',
    average: 'Promedio',
    total_play: 'Total de Reproducciones',
    view_graph: 'Ver Gráfico',
    time_spent_mins: 'Tiempo Empleado (Minutos)',
    play: 'Reproducir',
    ideal_path: 'Camino Ideal',
    user_incorrect_path: 'Camino Incorrecto del Usuario',
    ideal_path_taken: 'Camino Ideal Tomado por el Usuario',
    scenario: 'Escenario',
    option: 'Opción',
    spend: 'Gasto',
    average_spending_time: 'Tiempo Medio Empleado',
    activity_overview: 'Resumen de la Actividad',
    live_event: 'Evento en Vivo',
    live_assessment: 'Evaluación en Vivo',
    report_download: 'Descarga del Informe',
    all_workshops: 'Todos los Talleres',
    overview_average_activity: 'Resumen de la Actividad Media',
    overview_workshop_graph: 'Gráfico Resumen del Taller',
    mazes: 'Laberintos',
    correct_feedback: 'Feedback Correcto',
    incorrect_feedback: 'Feedback Incorrecto',
    checkin_checkout: 'Entrada - Salida',
    minutes: 'Minutos',
    incorrect_path: 'Camino Incorrecto',
    answer_not_available: 'Respuesta No Disponible',
    views: 'Visualizaciones',
    item: 'Elemento',
    questions: 'Preguntas',
    total_points: 'Puntos Totales',
    total_attempts: 'Intentos Totales',
    created_date: 'Fecha de Creación',
    host_name: 'Nombre del Anfitrión',
    host_section: 'Sección del Anfitrión',
    choose_products: 'Elegir Productos',
    add_to_basket: 'Añadir a la Cesta',
    basket: 'Cesta',
    times: 'Veces',
    scorms: 'SCORMs',
    skill_journey_overview: 'Resumen del Viaje de Habilidades',
    how_to_use: 'Cómo Usar',
    live_broadcast_description:
      'HEMOS INTEGRADO VÍDEO EN DIRECTO EN UN CONSTRUCTOR DE CURSOS FÁCIL DE USAR',
    live_broadcast_subdescription:
      'Con el sistema patentado de transmisión en directo de ShareLook, puedes crear engagement, automatizar el aprendizaje y maximizar el intercambio de conocimientos.',
    disclaimer: `Garantizo que mi viaje de habilidades no:
  - infringirá los derechos de terceros
  - contendrá ninguna ilegalidad, incluyendo difamación, obscenidad, indecencia, lascivia, pornografía, violencia, abuso, insultos, amenazas o contenido discriminatorio, incluso disfrazado con asteriscos
  - contendrá ataques personales contra otras personas
  - contendrá suplantación de otros participantes, figuras públicas o celebridades
  - contendrá grabaciones o información personal de cualquier individuo sin el consentimiento del mismo y no infringirá ninguna normativa de protección de datos en ninguna parte del mundo
  - contendrá cualquier tipo de solicitud comercial o cualquier forma de “spam”`,
    price: 'Precio',
    video_link: 'Enlace de Vídeo',
    category: 'Categoría',
    objectives: 'Objetivos',
    marketplace_description: 'Descripción del Mercado',

    live_discussion: 'DISCUSSION EN DIRECTO',
    poll: 'ENCUESTA',
    hide_grid: 'Ocultar Rejilla',
    show_grid: 'Mostrar Rejilla',
    stop_screen_share: 'Detener Compartir Pantalla',
    screen_share: 'Compartir Pantalla',
    mute: 'Silenciar',
    unmute: 'Quitar Silencio',
    raise_hand: 'Levantar la Mano',
    waiting__: 'Esperando...',
    audio_active: 'Audio Activo'
  },
  general: {
    save: 'Guardar',
    autosaved: 'Autoguardado',
    back_to: 'Volver a',
    by: 'Por',
    chat: 'Chat',
    completed: 'Completado',
    canceled: 'Cancelado',
    component: 'Componente',
    confirm: 'Confirmar',
    course: 'Curso',
    skill: 'Viaje de Habilidades',
    maze: 'MetaLaberinto',
    channel: 'Canal',
    podcast: 'Podcast',

    date: 'Fecha',
    details: 'Detalles',
    empty: 'Sin datos',
    enrolled: 'Inscrito',
    free: 'Gratis',
    graph: 'Gráfico',
    loading: 'Cargando...',
    lesson: 'Lección',
    lessons: 'Lecciones',
    live_assessment: 'Evaluación en vivo',
    live_event: 'Evento en vivo',
    no: 'No',
    of: 'De',
    or: 'O',
    organization: 'Organización',
    page: 'Página',
    pages: 'Páginas',
    personal: 'Personal',
    poll: 'Encuesta',
    rating: 'Valoración',
    reset: 'Reiniciar',
    signin: 'Iniciar Sesión',
    signup: 'Registrarse',
    soon: 'Pronto',
    type: 'Escribir',
    uploading: 'Subiendo...',
    yes: 'Sí',
    something_went_wrong: '¡Algo ha ido mal!',
    view_all: 'Ver todo',
    upload_successful: 'Carga Exitosa',
    upload_successful_message:
      'Sus documentos de Excel han sido cargados con éxito y están siendo procesados. Esto puede tardar varios minutos.',
    check_email_upload_successful:
      'Por favor <0>revise su correo electrónico </0> para el <1>informe</1> de la lista de usuarios cargada.',
    is_private: 'Privado'
  },

  account: {
    title: 'Cuenta',
    subtitle: 'Gestione la configuración y la información de su cuenta.',
    saved: 'Cuenta modificada con éxito'
  },

  assessments: {
    title: 'Evaluaciones',
    subtitle: 'Crear una evaluación',
    finished: 'La evaluación ha finalizado',
    countdown: 'La evaluación en vivo será transmitida en ',
    create: 'Crear una Evaluación',
    list_title: 'Sus Evaluaciones',
    delete_warning: '¿Está seguro de querer eliminar este Elemento? ',
    details_title: 'Agregar Detalles de la Evaluación',
    details_subtitle:
      'Nombre su Evaluación y dígale a su audiencia lo que pueden aprender de la misma.',
    disclaimer: `Garantizo que mi evaluación:
    - no infringe los derechos de terceros
    - no contiene ningún material ilegal, incluyendo contenido difamatorio, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultante, amenazador, o discriminatorio, ni siquiera disfrazado con asteriscos
    - no contiene ningún ataque contra otras personas
    - no contiene ninguna suplantación de otros participantes, figuras públicas o celebridades
    - no contiene registro alguno o información sobre ninguna persona sin su consentimiento y no infringe ninguna norma de protección de datos en ninguna parte del mundo
    - no contiene ninguna solicitud comercial o forma de “spam”'`
  },

  buildersettings: {
    title: 'Configuraciones de Publicación',
    subtitle: 'Configure quién puede ver e interactuar con su evento'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Agregar',
    add_page: 'Agregar Página',
    add_lesson: 'Agregar Lecciones',
    add_answer: 'Agregar nueva respuesta',
    add_group: 'Agregar Grupo',
    add_organization: 'Agregar Organización',
    add_question: 'Agregar pregunta',
    add_quiz: 'Agregar Quiz',
    add_users: 'Agregar usuarios',
    back: 'Volver',
    back_to_course: 'Volver a la Vista General del Curso',
    back_to_lesson: 'Volver a la Vista General de la Lección',
    back_to_media: 'Volver a Mediateca',
    back_to_details: 'Volver a detalles',
    cancel: 'Cancelar',
    clear: 'Limpiar',
    close: 'Cerrar',
    clone: 'Duplicar',
    close_lesson: 'Cerrar Lección',
    clone_course: 'Duplicar Curso',
    confirm: 'Confirmar',
    create: 'Crear',
    download: 'Descargar',
    download_mass_user_tamplate: 'Descargar Plantilla',
    add_mass_users: 'Agregar Usuarios Masivamente',
    upload_excel_list: 'Cargar Lista de Excel',
    delete: 'Eliminar Contenido Multimedia',
    edit: 'Editar',
    edit_course: 'Editar Curso',
    enroll: 'Inscribirse',
    finish: 'Finalizar',
    upload_image: 'Subir imagen',
    upload_image_video: 'Subir imagen o vídeo',
    select_media_library: 'Seleccionar mediateca',
    make_public: 'Hacer Público',
    make_private: 'Hacer Privado',
    make_org: 'Hacer Organización',
    media: 'Mediateca',
    my_theme: 'Mi tema',
    next: 'Siguiente',
    next_lesson: 'Siguiente lección',
    next_step: 'Paso Siguiente',
    previous_step: 'Paso Anterior',
    publish: 'Publicar',
    publish_assessment: 'Publicar su Evaluación',
    publish_course: 'Publicar su curso',
    publish_event: 'Publicar su evento',
    reset: 'Reiniciar',
    reset_elements: 'Reiniciar elementos',
    save: 'Guardar',
    creating: 'Creando...',
    updating: 'Actualizando...',
    saved: 'Guardado',
    save_for_later: 'Guardar para después',
    save_settings: 'Guardar ajustes',
    select_files: 'Seleccionar archivos',
    select_theme: 'Seleccionar tema',
    start_lesson: 'Iniciar lección',
    update: 'Actualizar',
    upload: 'Cargar',
    upload_audio: 'Cargar Audio',
    upload_photo: 'Cargar foto de perfil',
    upload_video: 'Cargar Vídeo',
    enrolled: 'Inscrito',
    unenroll: 'Darse de baja',
    from_library: 'Mediateca',
    remove: 'Eliminar',
    removed: 'Eliminado',
    start_broadcast: 'Iniciar Transmisión',
    end_broadcast: 'Finalizar Transmisión',
    camera: 'Cámara',
    screen: 'Pantalla',
    screen_with_camera: 'Pantalla con Cámara'
  },

  card: {
    quick_add: 'Agregar rápido',
    add: 'Agregar',
    clone: 'Duplicar',
    completed: 'lecciones completadas'
  },

  course: {
    upcoming_course: 'Próximo Curso',
    unPublishEvent: 'Cancelar Publicación del Evento',
    unPublishAssessment: 'Cancelar Publicación de Evaluación',
    pastCourse: 'Curso de Capacitación',
    upcoming: 'Próximo Evento en Vivo',
    pastEvent: 'Evento en Vivo Anterior',
    pastAssessment: 'Evaluación en Vivo Anterior',
    upcomingAssessment: 'Próxima Evaluación en Vivo',
    created: 'Fecha de Creación:',
    assignees: 'Cesionario',
    organisations:
      ' {{ organizations }} Organizaciones, <2> {{ users }} usuarios</2>',
    event_date: 'Fecha de evento en vivo <1> {{ date }} </1>',
    delete_warning: '¿Está seguro de querer eliminar esto?',
    clonning_no_lesson:
      'Por favor agregue al menos una Lección para duplicar este Curso.',
    clone_warning: '¿Está seguro de querer duplicar esto?',
    clone_success: 'Está en proceso de duplicación',
    disclaimer: `Garantizo que mi curso:
    - no infringe los derechos de terceros
    - no contiene ningún material ilegal, incluyendo contenido difamatorio, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultante, amenazador, o discriminatorio, ni siquiera disfrazado con asteriscos
    - no contiene ningún ataque contra otras personas
    - no contiene ninguna suplantación de otros participantes, figuras públicas o celebridades
    - no contiene registro alguno o información sobre ninguna persona sin su consentimiento y no infringe ninguna norma de protección de datos en ninguna parte del mundo
    - no contiene ninguna solicitud comercial o forma de “spam” `
  },

  coursecreate: {
    dropzone_text: 'Insertar multimedia',
    sidebar_text: 'Seleccione un tema <1/> para sus <3/> lecciones',
    delete_warning: '¿Está seguro de querer eliminar esta lección?'
  },

  coursepage: {
    quizview_loading: 'Revisando respuestas. Por favor espere...',
    quizview_answer: 'Su respuesta'
  },

  coursequiz: {
    title: 'Quizzes en todas las lecciones'
  },

  dashboard: {
    tooltip_title: 'No mostrar este vídeo nuevamente',
    page_title: 'Estadística de sus cursos’',
    page_subtitle: 'Estado de los cursos creados por usted',
    profile_add_info:
      'Agregue su <1>{{uncompletedText}}</1> para completar su perfil.',
    profile_build:
      'Cree su perfil <1>Aquí</1>, háganos saber sus intereses y habilidades.',
    profile_title: 'Fortaleza del Perfil',
    more_details: 'Más detalles'
  },

  errors: {
    answer: 'Por favor ingrese su respuesta',
    answer_correct: 'Seleccione la respuesta correcta',
    code: 'Por favor ingrese su código',
    criterion: 'Por favor ingrese el criterio',
    duration: 'La duración es obligatoria ',
    element: 'Por favor ingrese el elemento',
    email: 'Por favor ingrese su correo electrónico',
    email_invalid: 'El correo electrónico no es válido',
    feedback_correct: 'Por favor ingrese la retroalimentación caso correcto',
    feedback_incorrect:
      'Por favor ingrese la retroalimentación caso incorrecto',
    host: 'Por favor ingrese al anfitrión del evento',
    host_assessment: 'Por favor ingrese al anfitrión de la evaluación',
    image: 'Por favor suba una imagen',
    location: 'Por favor ingrese su ubicación',
    live_location: 'Por favor elija una ubicación de transmisión',
    limit: 'Por favor ingrese minutos de transmisión en vivo',
    min_3char: 'Mínimo 3 caracteres',
    number: 'por favor ingrese un número positivo.',
    host_email_require: `Los correos electrónicos del anfitrión son obligatorios.`,
    attendee_email_require: `Los correos electrónicos de los asistentes son obligatorios.`,
    name: 'Por favor ingrese su nombre',
    not_found_course: 'Curso no encontrado',
    not_found_event: 'Evento no encontrado',
    not_found_assessment: 'Evaluación no encontrada',
    password: 'Por favor ingrese su contraseña',
    password_digit: 'Al menos un dígito',
    password_short: 'Contraseña muy corta, mínimo 10 caracteres',
    password_special: 'Al menos un caracter especial',
    password_uppercase: 'Al menos un caracter en mayúscula',
    password_lowercase: 'Al menos un caracter en minúscula',
    phone: 'Por favor ingrese su número telefónico',
    phone_invalid: 'Número telefónico inválido',
    position: 'Por favor ingrese su posición',
    question: 'Por favor ingrese su pregunta',
    start_date: 'Fecha y Hora de Inicio son obligatorias ',
    tag: 'Por favor seleccione una etiqueta',
    topics: 'Por favor seleccione al menos un tema.',
    live_topics: 'Por favor agregue temas',
    title: 'Por favor ingrese el título',
    title_assessment: 'Por favor ingrese el título de la evaluación',
    title_course: 'Por favor ingrese el título del curso',
    title_empty: 'El título no puede estar vacío',
    title_event: 'Por favor ingrese el título del evento',
    title_lesson: 'Por favor ingrese el título de la lección',
    title_quiz: 'Por favor ingrese el nombre del quiz',
    username: 'Por favor ingrese su nombre de usuario',
    upload_error: 'Error – ¡Archivo no compatible!',
    upload_more_than_10: 'Sólo puede subir un máximo de 10 archivos a la vez.',
    topics_max: 'Por favor agregue 3 temas como máximo.',
    upload_excel: 'Por favor asegúrese de haber cargado el archivo correcto.',
    title_excel: 'Error al cargar la plantilla:',
    file_size_exceed: 'Tamaño de archivo excedido',
    subtitle_excel:
      'Por favor asegúrese de utilizar la plantilla proporcionada y que las columnas hayan sido llenadas correctamente.',
    select_broadcast_option:
      'Por favor seleccione una opción para transmitir este evento',
    multi_hosts_number_error:
      'El No. de presentadores no puede exceder lo especificado para el evento.',
    conference_people_number_error: `El No. de asistentes no puede exceder lo especificado para el evento.`,
    select_max_host: 'Seleccione al menos 1 presentador para el evento.',
    select_max_conference: 'Seleccione al menos 1 asistente para el evento.',
    stream_stop_error: 'La Transmisión en vivo se Detuvo Inesperadamente!',
    unsecure_context:
      'Error Fatal: El navegador no puede acceder a la cámara ni al micrófono debido a un contexto inseguro. Por favor instale SSL e ingrese vía https',
    ws_not_supported:
      'Error Fatal: WebSocket no es compatible con este navegador'
  },

  events: {
    title: 'Agregue Detalles del Evento en Vivo',
    change_host: 'Cambie el Anfitrión',
    finished: 'El evento ha finalizado',
    countdown: 'Evento en vivo se transmitirá en ',
    subtitle:
      'Nombre su evento en Vivo y dígale a su audiencia lo que pueden aprender del mismo.',
    poll_disabled: 'La encuesta no está disponible en este evento',
    disclaimer: `Garantizo que mi evento:
    - no infringe los derechos de terceros
    - no contiene ningún material ilegal, incluyendo contenido difamatorio, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultante, amenazador, o discriminatorio, ni siquiera disfrazado con asteriscos
    - no contiene ningún ataque contra otras personas
    - no contiene ninguna suplantación de otros participantes, figuras públicas o celebridades
    - no contiene registro alguno o información sobre ninguna persona sin su consentimiento y no infringe ninguna norma de protección de datos en ninguna parte del mundo
    - no contiene ninguna solicitud comercial o forma de “spam”`,
    prompt_message:
      'Al salir de esta página terminará su evento. ¿Está seguro de salir de esta página? ',
    duration_exceed_message:
      'Tiempo de transmisión excedido, la aplicación dejará de transmitir. ',
    before_schedule_message:
      'Usted está a punto de iniciar la transmisión antes de la hora del evento programado. Tenga en cuenta que el evento finalizará al detener la transmisión.',
    browser_unsupportive_message:
      'Su navegador no admite compartir la pantalla. Puede ver los navegadores compatibles en este enlace',
    cancel_switch_host_message:
      'El anfitrión no está disponible. El evento será continuado por usted.',
    coaching_prompt_message:
      'No puede dejar esta página hasta que el evento haya terminado.',
    event_modal_warn: '¿Quiere dejar este evento?',
    confirm_message: 'Su evento terminará si hace clic en OK.',
    screen_share_denied: 'Denegó compartir su pantalla',
    media_not_found:
      'La Cámara o el Micrófono no se encuentran o su uso no se permitió en su dispositivo.',
    media_not_access:
      'La Cámara o el Micrófono están siendo utilizados por algún otro proceso que no permite reconocer los dispositivos',
    constraint_error:
      'No se ha encontrado ningún dispositivo que se ajuste a sus restricciones de audio y vídeo. Puede cambiar las restricciones de audio y vídeo',
    media_access_denied: 'No se le permite acceder a la cámara y al micrófono.'
  },

  filters: {
    days7: 'Últimos 7 días',
    days15: 'Últimos 15 días',
    days30: 'Últimos 30 días',
    days365: 'Últimos 365 días',
    date: 'Fecha de Creación',
    relevance: 'Relevancia',
    popularity: 'Popularidad',
    name: 'Nombre',
    group: 'Grupo',
    Newest_to_Oldest: 'Del más Reciente al más Antiguo',
    Oldest_to_Newest: 'Del más Antiguo al más Reciente',
    A_Z: 'De la A a la Z',
    Z_A: 'De la Z a la A'
  },

  helpers: {
    password:
      'Para garantizar la seguridad de su cuenta, requerimos al menos una minúscula, número en su contraseña. Deberá tener mínimo 10 caracteres.',
    phone:
      'Por favor incluya el código telefónico de su país, por ejemplo: +65',
    username:
      'Su nombre de usuario es considerado como información pública y se comparte con otros usuarios cuando es necesario. Por tal motivo, le recomendamos que no utilice información personal en su nombre de usuario.',
    public_description_normal:
      'Su <0><0/></0> se ha guardado y se considera Privado por defecto. Esto significa que sólo usted puede visualizar este contenido. Para publicarlo puede seleccionar una de las siguientes opciones. Publicar su curso en Público significa que estará disponible para todos los usuarios de la plataforma. La opción Usuarios Específicos le permitirá compartir su curso con usuarios específicos utilizando las direcciones de correo electrónico asociadas con sus cuenta de Sharelook.',
    public_description_admin:
      'Este <0><0/></0> se ha guardado y se considera Privado por defecto.  Esto significa que sólo usted (y el creador del contenido) pueden visualizarlo. Para publicar este contenido puede seleccionar una de las siguientes opciones. Publicar su curso en Público significa que estará disponible para todos los usuarios de la plataforma - incluyendo aquellos fuera de su organización. Publicarlo a la organización significa que todos los usuarios dentro de la organización podrán visualizarlo. También puede publicarlo en 1 o más grupos, lo que significa que sólo los usuarios dentro de esos grupos podrán visualizarlo. Por último, tiene la opción de publicarlo a usuarios específicos dentro y fuera de su organización utilizando sus direcciones de correo electrónico de Sharelook.'
  },

  labels: {
    add: 'Agregar',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Tipo de respuesta',
    answers: 'Respuestas',
    back_to_quiz: 'Volver a la lista de Quiz',
    back_to_question: 'Volver a la lista de preguntas',
    chat: 'Chat',
    chat_available: 'El Chat no está disponible en este evento',
    chat_report: 'Informe del Chat',
    choice_single: 'Selección Simple',
    choice_multiple: 'Selección Múltiple',
    choice_free: 'Selección "libre"',
    choice_sorting: 'Selección por "Sorteo"',
    choice_matrix: 'Selección de Clasificación de "Matriz" ',
    clone_lesson_permission: 'Permiso para Duplicar',
    code: 'Código',
    correct: 'Correcto',
    created: 'Fecha de creación',
    clone_modal: 'Duplicar curso',
    cloning_course: 'Duplicando curso...',
    cloning: 'Duplicando...',
    cloning_course_desc: 'Este proceso puede tardar. Por favor espere',
    cloning_success: 'Curso "<0/>" duplicado satisfactoriamente',
    description: 'Descripción',
    disclaimer: 'Descargo de Responsabilidad',
    drop_file: 'Suelte el archivo aquí...',
    duration: 'Duración',
    edit: 'Editar',
    email: 'Correo electrónico',
    event: 'Evento',
    event_all: 'Todos sus Eventos',
    event_date: 'Fecha/Hora Local del Evento en Vivo',
    event_this: 'Este Evento',
    expire: 'Expira en',
    expiry_date: 'Fecha de expiración',
    forgot: '¿Olvidó su contraseña?',
    group: 'Grupo',
    groups_list: 'Lista de Grupos',
    host: 'Anfitrión',
    id_annotation: 'id de Anotación',
    id_quiz: 'id del Quiz',
    incorrect: 'Incorrecto',
    interests: 'Intereses',
    invited: 'Invitado',
    live_chat: 'Debate en vivo',
    live_stream_limit: 'Minutos de transmisión en vivo',
    contact_text:
      'Para cambiar su límite mensual de transmisión en vivo, contáctenos',
    contact_admin:
      '<0>Si desea cambiar su límite mensual de transmisión en vivo, contáctenos al correo </0> <1>admin@sharelook.com</1>',
    limit_stream_text:
      'Minutos de Transmisión en Vivo Restantes: <0>{{ limit }}</0> minutos <1/><2/> <3>Para cambiar su límite mensual de transmisión en vivo, contáctenos al correo </3> <4>admin@sharelook.com</4>',
    location: 'Ubicación',
    lessons: 'Lecciones',
    location_broadcast: 'Ubicación del Servidor del Anfitrión',
    location_broadcast_subtitle:
      'Agregue una ubicación que sea la más cercana a la ubicación del anfitrión de la transmisión para reducir el retraso audiovisual',
    media_manager: 'Administrar Contenido Multimedia',
    minutes: 'Minutos',
    name: 'Nombre',
    online_quiz: 'Quiz en Línea',
    organiser: 'Autor',
    organization: 'Organización',
    overall_emotion: 'Experiencia General:',
    organizations_list: 'Lista de Organizaciones',
    password: 'Contraseña',
    participants: 'Participantes',
    picture: 'Imagen (16:9)',
    phone: 'Teléfono',
    photo: 'Foto',
    poll: 'Encuesta',
    position: 'Posición',
    processing: 'Procesando',
    privacy_settings: 'Ajustes de privacidad',
    question: 'Preguntas',
    quiz_create: 'Crear Nuevo Quiz',
    quiz_name: 'Nombre del Quiz',
    quiz_update: 'Actualizar quiz',
    select_organization: 'Seleccione una organización',
    settings: 'Ajustes',
    show: 'Mostrar',
    show_graph: 'Mostrar resultado gráfico',
    signin: 'Iniciar sesión',
    signup: 'Registrarse',
    sort_by: 'Ordenar Por',
    start_date: 'Fecha de Inicio',
    tags: 'Etiquetas',
    terms: 'Estoy de acuerdo con estas <1>condiciones de uso</1>.',
    title: 'Título',
    topics: 'Temas',
    topic: 'Tema',
    total_comments: 'Número de Comentarios',
    username: 'Nombre de Usuario',
    users_list: 'Lista de Usuarios',
    users_emails: 'Insertar correos electrónicos de usuarios específicos',
    description_specifiction_email:
      'Por favor coloque 1 dirección de correo electrónico por línea para compartir esto con varios usuarios específicos.',
    message_specific_email:
      'Por favor introduzca el correo electrónico del usuario específico.',
    viewers: 'Espectadores',
    edit_course: 'Editar',
    edit_assessment: 'Editar',
    edit_event: 'Editar',
    delete_course: 'Eliminar',
    delete_event: 'Eliminar',
    delete_assessment: 'Eliminar',
    view_course: 'Ver',
    view_event: 'Ver',
    view_assessment: 'Ver',
    date_event: 'Fecha de evento en vivo',
    date_assessment: 'Fecha de evaluación en vivo',
    clone_of: 'Duplicar',
    clone_course:
      'Crear un duplicado de este curso que se puede modificar independientemente del original, incluyendo todas las lecciones y páginas.',
    make: 'Hacer',
    available_to: 'disponible para cualquier usuario de Sharelook',
    uploaded_by: 'Cargado por: ',
    course: 'Curso',
    assessment: 'Evaluación',
    user_not_exist: 'El usuario no existe, ¿quiere enviar una invitación?',
    check_user: 'Aviso',
    user_not_exist_in_org:
      'El usuario no existe en esta organización, ¿quiere enviar una invitación?',
    title_modal_stream:
      'Cambiar Límite de Transmisión en Vivo de la Organización',
    des_warning_stream: 'Está a punto de cambiar',
    monthly_stream: 'límite mensual de transmisión en vivo:',
    min_per_month: 'minutos/mes',
    broadcast_label: 'Quiero hacer:',
    hosts_emails: `Insertar correos electrónicos específicos del anfitrión`,
    attendee_emails: `Insertar correos electrónicos específicos de asistentes`,
    description_host_specifiction_email:
      'Por favor coloque 1 dirección de correo electrónico por línea.',
    presenter_label: 'Presentador',
    presenter_label_conference: 'No. de personas',
    event_privacy: 'Modo conferencia'
  },

  broadcastOptions: {
    stream_from_phone: 'Transmisión en Vivo con mi teléfono',
    other_webrtc: 'Webminar desde mi PC',
    multihost: 'Multidifusión de Webinar desde mi PC',
    peer2peer: 'Sesión de capacitación',
    conference: 'Conferencia en Vivo'
  },

  lessoncreate: {
    title: 'Agregar detalles de la lección',
    subtitle:
      ' Nombre su lección y dígale a su audiencia lo que pueden aprender de la misma.',
    input_label_title: 'Título de la lección',
    input_label_topics: 'Temas de la lección',
    input_label_description: 'Descripción de la lección',
    delete_warning: '¿Está seguro de querer eliminar esta página?'
  },

  lessonoverview: {
    title: 'Agregar Lección',
    subtitle: 'Agregar lección existente o crear una nueva',
    new_lesson: 'Crear una nueva lección',
    new_lesson_sub: '¡Crear una nueva lección desde cero!',
    existing_lesson: 'Seleccionar lección existente',
    existing_lesson_sub:
      'Enlace a una lección existente, los cambios realizados en esta lección también afectarán esta lección en otros cursos.',
    clone_lesson: 'duplicar lección existente',
    clone_lesson_sub:
      'Hacer una copia única de la lección en este curso, los cambios realizados en esta lección no afectarán la lección original.',
    clone_lesson_modal_sub:
      'Por favor haga clic en el botón duplicar debajo de la lección que le gustaría añadir a su curso.'
  },

  management: {
    groups_title: 'Administrar grupos',
    delete_warning: '¿Está seguro?',
    organizations_title: 'Mis Organizaciones',
    organizations_subtitle: 'Agregar organizaciones a su lista',
    users_title: 'Administrar usuarios',
    users_position: 'Gerente de Cuenta Senior',
    user_not_found: 'Usuario no Encontrado',
    select_org:
      'Por favor busque y elija una organización para administrar a los usuarios'
  },

  audio: {
    modal_title: 'Insertar Audio',
    list_view: 'Ver Lista',
    create_audio_modal_title: 'Crear Audio',
    edit_audio_modal_title: 'Editar Audio',
    public_audio_not_found: 'Audio no encontrado.',
    private_audio_not_found: 'No ha cargado ningún audio todavía',
    are_you_sure_to_delete: '¿Está seguro de querer eliminarlo?',
    type_something: 'Escribir Algo',
    select_voice: 'Seleccionar',
    file_name: 'Nombre del Archivo',
    description: 'Descripción',
    topic: 'Tema',
    key_words_tag: 'Etiqueta de palabras clave',
    mp3_audio: 'Audio MP3',
    created: 'Creado',
    duration: 'Duración',
    close: 'cerrar'
  },

  image: {
    modal_title: 'Insertar Imagen',
    image: 'Imagen',
    pixel: 'Píxel',
    dimension: 'Dimensión',
    public_image_not_found: 'Imagen no encontrada.',
    private_image_not_found: 'No ha cargado ninguna imagen todavía'
  },

  annotation: {
    modal_title: 'Anotación'
  },

  text: {
    modal_title: 'Editor de Texto'
  },

  video: {
    modal_title: 'Insertar Vídeo',
    image: 'Video',
    mp4_video: 'Vídeo MP4',
    public_video_not_found: 'Vídeo no encontrado.',
    private_video_not_found: 'No ha cargado ningún vídeo todavía'
  },

  media: {
    title: 'Mediateca',
    subtitle: 'Biblioteca de sus archivos',
    modal_title: 'Subir contenido multimedia',
    delete_warning: 'Confirme para eliminar',
    delete_message:
      'El contenido multimedia eliminado seguirá apareciendo en las páginas donde ha sido utilizado',
    dropzone_text: 'o Arrastrar y Soltar',
    delete_success: 'Contenido multimedia eliminado con éxito',
    upload_file: 'Subir archivo',
    drag_drop: 'o Arrastrar y Soltar',
    import_file: 'Importar archivo(s) desde su computadora',
    no_media: 'No ha cargado ningún contenido multimedia todavía',
    media_type: 'Tipo de Contenido Multimedia',
    video: 'Vídeo',
    image: 'Imagen',
    audio: 'Audio',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Contenido multimedia no encontrado.',
    of: 'of',
    disclaimer: ` Garantizo que mi contenido multimedia:
    - no infringe los derechos de terceros
    - no contiene ningún material ilegal, incluyendo contenido difamatorio, obsceno, indecente, lascivo, pornográfico, violento, abusivo, insultante, amenazador, o discriminatorio, ni siquiera disfrazado con asteriscos
    - no contiene ningún ataque contra otras personas
    - no contiene ninguna suplantación de otros participantes, figuras públicas o celebridades
    - no contiene registro alguno o información sobre ninguna persona sin su consentimiento y no infringe ninguna norma de protección de datos en ninguna parte del mundo
    - no contiene ninguna solicitud comercial o forma de “spam”'`
  },

  navigation: {
    account: 'Cuenta',
    assessments: 'Evaluaciones',
    dashboard: 'Tablero',
    groups: 'Administrar Grupo',
    logout: 'Cerrar Sesión',
    organisations: 'Organizaciones',
    organizations_users: 'Organizaciones y Usuarios',
    reports: 'Informes',
    schedule: 'Calendario',
    nowLive: 'Transmitir',
    training: 'Capacitación',
    users: 'Usuarios',
    workshop: 'Mi Taller'
  },

  onboarding: {
    step1_title: 'Paso 1: Cuéntenos un poco sobre usted',
    step1_subtitle:
      '¿Cuál es su nombre? ¿De dónde es? ¿Cuál es su cargo en su trabajo?',
    step2_title: 'Paso 2: Seleccione Alguna Habilidad en la que Podría Mejorar',
    step2_subtitle:
      'A continuación, díganos lo que le gustaría entender mejor. ¿Tal vez algo que quiera aprender? ¿Un nuevo campo de estudio? ¿Lo que su ser querido hace?'
  },

  pagebuilder: {
    title: 'Crear Lección',
    subtitle:
      'Es hora de crear el contenido para que su público aprenda de usted, pueden ser imágenes, vídeos e infografías',
    select_layout: 'Seleccione un Diseño de Pagina',
    template1: 'En blanco',
    template2: 'Título y Subtítulo',
    template3: 'Título y Texto',
    template4: 'Título, Contenido Multimedia y Texto',
    template5: 'Título y Contenido Multimedia',
    template6: 'Título y Quiz'
  },

  pageconstructor: {
    title: 'Crear y Duplicar Lección',
    subtitle:
      'Es hora de crear el contenido para que su público aprenda de usted, puede agregar imágenes, vídeos e infografías'
  },

  passwordreset: {
    success_coded:
      'Hemos enviado por correo electrónico un código de confirmación a la dirección que usted proporcionó, por favor escriba el código en el campo de abajo para establecer una nueva contraseña.',
    success_changed:
      'Ha configurado con éxito una nueva contraseña. Puede iniciar sesión ahora.'
  },

  placeholders: {
    search: 'Buscar',
    answer: 'Responder',
    chat: 'Decir algo...',
    code: 'Código',
    criterion: 'Criterio',
    date_event: 'Seleccionar fecha y hora',
    date_start: 'Fecha de inicio',
    date_expire: 'Fecha de expiración',
    description: 'Descripción',
    elements: 'Ordenar elementos',
    email: 'Correo Electrónico',
    feedback_correct: 'Retroalimentación caso Correcto',
    feedback_incorrect: 'Retroalimentación caso Incorrecto',
    host: 'Anfitrión',
    keywords: 'Buscar palabra(s) clave',
    lesson_description: 'Descripción de la Lección',
    location: 'Ubicación',
    minutes: 'Minutos',
    name: 'Nombre',
    organiser: 'Autor',
    organization: 'Organización',
    password: 'Contraseña',
    phone: 'Teléfono',
    photo: 'Foto',
    picture: 'Imagen',
    point: 'Punto',
    position: 'Posición',
    question: 'Pregunta',
    quiz: 'Nombre del Quiz',
    search_course: 'Buscar por Curso',
    search_media: 'Buscar contenido multimedia',
    search_name: 'Buscar por Nombre',
    search_title: 'Buscar por Título',
    search_training: 'Buscar Capacitación',
    settings: 'Ajustes',
    tags: 'Etiquetas',
    title: 'Título',
    topics: 'Temas',
    username: 'Nombre de usuario',
    keyword: 'Palabras clave',
    max_500_characters: 'Max 500 Caracteres',
    no_description: 'Este archivo no tiene una descripción',
    no_keyword: 'Este archivo no tiene palabras clave',
    no_topics: 'Este archivo no tiene un conjunto de temas',
    feedback: 'Mensaje',
    contact: '¿Cómo podemos ayudarle?'
  },

  publishsettings: {
    title: ' Configuración de Publicación ',
    event_subtitle: 'Configure quién puede ver e interactuar con su evento',
    assessment_subtitile:
      'Nombre su Evaluación y dígale a su audiencia lo que pueden aprender de la misma',
    course_subtitle: 'Configure quién puede ver e interactuar con su curso',
    /* disclaimer:
  1.	Registro

  Al registrarse como usuario/crear una cuenta, usted acepta nuestro [User Agreement] [Acuerdo de Usuario] y reconoce haber leído nuestra [Privacy Policy] [Política de Privacidad]

  2.	Crear Curso

  Al utilizar nuestras herramientas y crear el contenido de un curso, usted acepta nuestro [User Agreement] [Acuerdo de Usuario] y reconoce haber leído nuestra [Privacy Policy] [Política de Privacidad]

  3.	Crear Evento

  Al utilizar nuestras herramientas y crear un evento, usted acepta nuestro [User Agreement] [Acuerdo de Usuario] y reconoce haber leído nuestra [Privacy Policy] [Política de Privacidad]

  4.	Crear Evaluación

  Al utilizar nuestras herramientas y crear una evaluación, usted acepta nuestro [User Agreement] [Acuerdo de Usuario] y reconoce haber leído nuestra [Privacy Policy] [Política de Privacidad] */
    dates_validation_error: 'Ambas fechas deben ser llenadas.',
    emails_validation_error: 'La lista de correo electrónico no es válida.',
    specific_email_validation_error: 'Sólo se permite un correo electrónico.',
    i_agree_to_these: 'Yo acepto estos ',
    terms_and_conditions: 'términos y condiciones.',
    PublicDescription:
      'Usuarios independientes: (opciones privadas y públicas)su [Course|Event|Assessment] [Curso|Evento|Evaluación] ha sido guardado y se considera Privado por defecto. Esto significa que sólo usted puede visualizar este contenido. Para publicarlo puede seleccionar hacerlo público a continuación. Esto quiere decir que el curso estará disponible para todos los usuarios de la plataforma.',
    OrganisationsDescription:
      'Usuarios de una Org: (En lugar de ""Finalizar"" utilice ""Publicar"" y llévelos a la página de publicación igual que otros usuarios pero no tendrá ninguna de las opciones de publicación.)Su [Course|Event|Assessment] [Curso|Evento|Evaluación] ha sido guardado y es privado. Esto significa que sólo usted y los Administradores de su organización pueden visualizarlo. Como usuario, no puede publicar su contenido dentro de la organización debido a que esto requiere derechos de administrador. Por favor contacte a uno de sus Administradores y pídale que coloque su contenido público, a toda la organización, a grupos específicos dentro de su organización o a usuarios específicos.',
    OrganisationGroupsDescription:
      'Administradores de una Org: (Para contenido hecho dentro de la organización: Privado, público, organización, grupos, usuarios específicos):Este [Course|Event|Assessment] [Curso|Evento|Evaluación] ha sido guardado y se considera Privado por defecto. Esto significa que sólo usted (y el creador del contenido) pueden visualizar este contenido. Para publicarlo puede seleccionar una de las opciones a continuación. Publicar su curso en Público significa que estará disponible para todos los usuarios de la plataforma – incluyendo aquellos fuera de su organización. Publicarlo a la organización significa que todos los usuarios dentro de la organización podrán visualizarlo. También puede publicarlo en 1 o más grupos, lo que significa que sólo los usuarios dentro de esos grupos podrán visualizarlo. Por último, tiene la opción de publicarlo a usuarios específicos dentro y fuera de la organización utilizando su dirección de correo electrónico de la cuenta de Sharelook.',
    SpecificUsersDescription:
      'Usuarios Independientes Pagados: (privado, público y usuarios específicos)Su [Course|Event|Assessment] [Curso|Evento|Evaluación] ha sido guardado y se considera Privado por defecto. Esto significa que sólo usted puede visualizar este contenido. Para publicarlo puede seleccionar una de las opciones a continuación. Publicar su curso en Público significa que estará disponible para todos los usuarios de la plataforma. La opción Usuarios Específicos le permitirá compartir su curso con usuarios específicos utilizando sus direcciones de correo electrónico de la cuenta de Sharelook.'
  },

  quiz: {
    quiz_empty: 'Todavía no ha creado un quiz',
    questions_empty: 'Todavía no ha creado una pregunta'
  },

  regions: {
    asia_pacific_australia: 'Australia',
    asia_pacific_india: 'India',
    asia_pacific_japan: 'Japón',
    asia_pacific_s_korea: 'Corea del Sur',
    asia_pacific_singapore: 'Singapur',
    asia_pacific_taiwan: 'Taiwan',
    eu_belgium: 'Bélgica',
    eu_germany: 'Alemania',
    eu_ireland: 'Irlanda',
    south_america_brazil: 'Brasil',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'Carolina del Sur',
    us_east_virginia: 'Virginia',
    us_west_california: 'California',
    us_west_oregon: 'Oregón'
  },

  reports: {
    title: 'Informes'
  },

  signup: {
    success_step1:
      'Hemos enviado por correo electrónico un código de verificación a la dirección que usted proporcionó, por favor escriba el código en el siguiente campo para confirmar su registro.',
    success_step2: 'Gracias. Se ha registrado correctamente.',
    privacy: `Acepto las <1> condiciones de uso</1> y <3> política de privacidad</3>de Sharelook`
  },

  stream: {
    emotion_impressive: 'Impresionante',
    emotion_unimpressive: 'No destaca',
    message_not_started: 'Próximamente',
    message_running: 'En vivo',
    message_processing:
      'Actualmente estamos procesando la grabación en vivo para su reproducción. Por favor, vuelva más tarde para ver el vídeo y seguir añadiendo valoraciones y comentarios'
  },

  tabs: {
    audience: 'Audiencia',
    course: 'Vista general del Curso',
    details: 'Detalles del Evento en Vivo',
    description: 'Descripción',
    host: 'Anfitrión',
    lesson: 'Vista general de la Lección',
    lessons: 'Lecciones',
    overview: 'Vista general',
    page: 'Creador de la página',
    publish: 'Publicar',
    settings: 'Configurar Publicación',
    total_views: 'Visualizaciones Totales',
    live_participates: 'Participantes en Vivo',
    live_chats: 'Chats en Vivo',
    live_quiz: 'Encuestas en Vivo',
    trainer_rating: 'Valoración del Entrenador',
    trainer_times: 'Tiempos de Entrenador',
    courses_quizzes: 'Quizzes de los Cursos',
    user_list: 'Lista de Usuarios',
    discussion: 'Debate',
    notes: 'Mis Notas'
  },

  topics: {
    SALES_TRAINING: 'Capacitación en Ventas',
    NEGOTIATION_TRAINING: 'Capacitación en Negociación',
    CROSS_CULTURAL_AWARENESS: 'Sensibilización Intercultural',
    NETWORKING_SKILLS: 'Habilidades de Networking',
    SOFTWARE_ARCHITECTURE: 'Arquitectura de Software',
    PROJECT_MANAGEMENT: 'Gestión de Proyectos',
    DIGITAL_TRANSFORMATION: 'Transformación Digital',
    IT_CONSULTING: 'Consultoría Tecnológica',
    MANAGEMENT_CONSULTING: 'Consultoría de Gestión',
    HR_CONSULTING: 'Consultoría de Recursos Humanos',
    INTERNET_OF_THINGS: 'Internet de las Cosas (IdC)',
    CYBERSECURITY: 'Seguridad Informática',
    PRIVACY_AND_GDRP: 'Privacidad y RGPD'
  },

  training: {
    title: 'Capacitación',
    title_assessment: 'Evaluaciones',
    subtitle: 'Cursos y Eventos en Vivo',
    enrolled_title: 'Cursos Inscrito y Eventos en Vivo',
    enrolled_subtitle:
      'Cursos y Eventos en Vivo en los que se encuentra inscrito',
    enrolled_message:
      'Actualmente usted no está inscrito en ningún curso o evento.',
    past_live_event_title: 'Eventos en Vivo Anteriores',
    past_live_event_subTitle: 'Eventos en Vivo Finalizados',
    past_live_event: 'Actualmente no hay eventos en vivo anteriores.',
    recomended_title: 'Cursos y Eventos en Vivo Recomendados ',
    now_live_event_title: 'Ahora en Vivo',
    now_live_event_subTitle:
      'Eventos que están en vivo ahora o lo estarán muy pronto',
    now_live_event: 'Actualmente no hay eventos en vivo.',
    webinar_event_title: 'Canal de Webinar',
    webinar_event_subTitle: 'Webinarios Finalizados',
    webinar_event: 'Actualmente no hay webinarios.',
    p2p_event_title: 'Sesiones de entrenamiento',
    p2p_event_subTitle: 'Sesión de Entrenamiento Finalizada',
    p2p_event: 'Actualmente no hay sesiones de entrenamiento.',

    now_live_assessment_title: 'Ahora en Vivo',
    now_live_assessment_subTitle:
      'Evaluaciones que están en vivo ahora o lo estarán muy pronto',
    now_live_assessment_message: 'Actualmente no hay evaluaciones en vivo.',

    upcoming_assessment_title: 'Próximas Evaluaciones en Vivo',
    upcoming_assessment_subtitle: 'Próximas Evaluaciones en Vivo',
    upcoming_assessment_message:
      'Actualmente no hay próximas evaluaciones en vivo.',

    past_live_assessment_title: 'Evaluaciones en Vivo Anteriores',
    past_live_assessment_subTitle: 'Evaluaciones en Vivo Finalizadas',
    past_live_assessment_message:
      'Actualmente no hay evaluaciones en vivo anteriores.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Hemos escogido cursos y eventos en vivo basados en su <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Buscar Capacitación',
    search_assessment: 'Buscar Evaluación',
    recomended_message: 'Actualmente no hay cursos o eventos recomendados.'
  },

  warnings: {
    delete: '¿Está seguro?'
  },

  workshop: {
    title: 'Mi Taller',
    subtitle: 'Crear un curso o ser anfitrión de un evento en vivo propio',
    new_course: 'Crear un curso nuevo',
    new_event: 'Crear un nuevo evento en vivo',
    new_assessment: 'Crear una nueva evaluación en vivo',
    courses_title: 'Cursos y Eventos en Vivo Creados',
    courses_subtitle:
      'Edite y Publique su curso creado y planifique eventos en vivo',
    tags_course: 'Curso',
    tags_live: 'Evento en Vivo',
    tags_assessment: 'Evaluación en Vivo'
  },

  help_center: {
    sidebar: {
      title: '¿Como podemos ayudarle? ',
      back_to: 'Tablero'
    },
    menu: {
      help_center: 'Centro de Ayuda',
      whats_new: 'Lo nuevo',
      feedback: 'Comentarios',
      feedback_title: 'Enviar comentarios a sharelook',
      terms_and_conditions: 'Condiciones de uso',
      privacy_policy: 'Política de Privacidad',
      contact_us: 'Contáctenos'
    },
    get_started: {
      title: 'Comience con share look',
      description: {
        main:
          'HEMOS INTEGRADO VIDEOS EN VIVO EN UN CREADOR DE CURSOS FÁCIL DE UTILIZAR',
        tagline:
          'Con el sistema de transmisión en vivo de ShareLook, puede crear interacción, automatizar el aprendizaje y maximizar el intercambio de conocimientos.'
      }
    },
    whats_new: {
      title: 'Comience con sharelook',
      description: {
        main:
          '¿Sabía que puede diseñar el estilo de aprendizaje con Storytelling en poco tiempo y no es costoso? Debe combinar el creador de cursos de ShareLook y los respectivos talentos. Pregúntenos "CÓMO”',
        tagline: ''
      }
    },
    create_workshop: 'Cómo Crear un Taller',
    create_course: 'Cómo Crear un Curso',
    create_user: 'Cómo Crear un Usuario',
    create_group: 'Cómo Crear un Grupo',
    create_webinar: 'Cómo Crear un Webinar',
    create_live_event: 'Cómo Crear un Evento en Vivo',
    create_live_assessment: 'Cómo Crear una Evaluación en Vivo',
    create_live_on_mobile: 'Crear en Vivo en el Móvil',
    personalize_profile: 'Personalizar un Perfil',
    manage_group: 'Administrar Grupo',
    report: 'Informe',
    add_annotations: 'Cómo Agregar Anotaciones/Ventanas emergentes',
    add_audio: 'Cómo Agregar Audio',
    add_header_and_footer: 'Agregar Encabezado y Pie de Página',
    add_image: 'Cómo Agregar Imagen',
    add_quiz_content: 'Cómo Agregar Contenido en el Quiz',
    add_text_content: 'Cómo Agregar Contenido de Texto',
    add_user: 'Cómo Agregar Usuarios',
    add_video: 'Cómo Agregar Vídeo',
    clone_course: 'Cómo Duplicar Curso',
    find_live_broadcast: 'Cómo Encontrar Transmisión en Vivo',
    contact_us: {
      title: 'Contáctenos',
      subject_placeholder: 'Escriba un tema*',
      content_placeholder: 'Escriba un mensaje*',
      subject_required: '*El tema es obligatorio',
      content_required: '*El mensaje es obligatorio',
      submit: 'Enviar',
      cancel: 'Cancelar',
      sent: 'Enviado'
    },
    feedback: {
      title: 'Enviar comentarios a sharelook',
      attach_title: 'Adjuntar un archivo',
      choose: 'Elegir archivo',
      detail: 'El archivo será compartido con el equipo de soporte',
      content_placeholder: 'Escriba un mensaje*',
      content_required: '*El mensaje es obligatorio',
      submit: 'Enviar',
      cancel: 'Cancelar',
      sent: 'Enviado'
    }
  },
  discussion: {
    join_discussion: 'Unirse al Debate'
  },
  notes: {
    title: 'Mis notas',
    add_note: 'Agregar nota nueva'
  }
}
